var normalizedPath = function normalizedPath(path) {
  return path ? "".concat(path, "/").replace(/\/+$/, '/') : '';
};

export default (function () {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'https://docucdn-a.akamaihd.net/olive/images/2.72.0';
  var baseUrl = normalizedPath(path);
  return {
    logoDsWhite: "".concat(baseUrl, "Logo-DS-White.svg"),
    classicEditor: "".concat(baseUrl, "ace/classic-editor.svg"),
    navArrow: "".concat(baseUrl, "admin/nav-arrow.svg"),
    accountsBlue: "".concat(baseUrl, "admin/tiles/accounts-blue.png"),
    accounts: "".concat(baseUrl, "admin/tiles/accounts.svg"),
    adminTiles: "".concat(baseUrl, "admin/tiles/admin-tiles.svg"),
    appliancePoolsBlue: "".concat(baseUrl, "admin/tiles/appliance-pools-blue.png"),
    appliancePools: "".concat(baseUrl, "admin/tiles/appliance-pools.svg"),
    auditLogsBlue: "".concat(baseUrl, "admin/tiles/audit-logs-blue.png"),
    auditLogs: "".concat(baseUrl, "admin/tiles/audit-logs.svg"),
    bulkActionsBlue: "".concat(baseUrl, "admin/tiles/bulk-actions-blue.png"),
    bulkActions: "".concat(baseUrl, "admin/tiles/bulk-actions.svg"),
    connectedAppsBlue: "".concat(baseUrl, "admin/tiles/connected-apps-blue.png"),
    connectedApps: "".concat(baseUrl, "admin/tiles/connected-apps.svg"),
    dataFeedsBlue: "".concat(baseUrl, "admin/tiles/data-feeds-blue.png"),
    dataFeeds: "".concat(baseUrl, "admin/tiles/data-feeds.svg"),
    directoryRoutingBlue: "".concat(baseUrl, "admin/tiles/directory-routing-blue.png"),
    directoryRouting: "".concat(baseUrl, "admin/tiles/directory-routing.svg"),
    displayBlue: "".concat(baseUrl, "admin/tiles/display-blue.png"),
    display: "".concat(baseUrl, "admin/tiles/display.svg"),
    domainsBlue: "".concat(baseUrl, "admin/tiles/domains-blue.png"),
    domains: "".concat(baseUrl, "admin/tiles/domains.svg"),
    envelopeTransferBlue: "".concat(baseUrl, "admin/tiles/envelope-transfer-blue.png"),
    envelopeTransfer: "".concat(baseUrl, "admin/tiles/envelope-transfer.svg"),
    groupsBlue: "".concat(baseUrl, "admin/tiles/groups-blue.png"),
    groups: "".concat(baseUrl, "admin/tiles/groups.svg"),
    orgAdminsBlue: "".concat(baseUrl, "admin/tiles/org-admins-blue.png"),
    orgAdmins: "".concat(baseUrl, "admin/tiles/org-admins.svg"),
    organizationDetailsBlue: "".concat(baseUrl, "admin/tiles/organization-details-blue.png"),
    organizationDetails: "".concat(baseUrl, "admin/tiles/organization-details.svg"),
    permissionSetsBlue: "".concat(baseUrl, "admin/tiles/permission-sets-blue.png"),
    permissionSets: "".concat(baseUrl, "admin/tiles/permission-sets.svg"),
    profileBlue: "".concat(baseUrl, "admin/tiles/profile-blue.png"),
    profile: "".concat(baseUrl, "admin/tiles/profile.svg"),
    providersBlue: "".concat(baseUrl, "admin/tiles/providers-blue.png"),
    providers: "".concat(baseUrl, "admin/tiles/providers.svg"),
    securityBlue: "".concat(baseUrl, "admin/tiles/security-blue.png"),
    security: "".concat(baseUrl, "ndse/security.svg"),
    usersBlue: "".concat(baseUrl, "admin/tiles/users-blue.png"),
    users: "".concat(baseUrl, "admin/tiles/users.svg"),
    assignFieldsTaggerCssV02: "".concat(baseUrl, "animations/onboarding-se/assignFieldsTagger_CSS_v02.svg"),
    sendDragTaggerCssV05: "".concat(baseUrl, "animations/onboarding-se/sendDragTagger_CSS_v05.svg"),
    sendDragTaggerV02: "".concat(baseUrl, "animations/onboarding-se/sendDragTagger_v02.svg"),
    signReturnTaggerV03: "".concat(baseUrl, "animations/onboarding-se/signReturnTagger_v03.svg"),
    svgoConfig: "".concat(baseUrl, "animations/svgo.config.js"),
    avatarPlaceholderWhite: "".concat(baseUrl, "avatar-placeholder-white.png"),
    avatarPlaceholder: "".concat(baseUrl, "avatar-placeholder.svg"),
    badgeBriefcase: "".concat(baseUrl, "badges/badge_briefcase.svg"),
    badgeCalendar: "".concat(baseUrl, "badges/badge_calendar.svg"),
    badgeCrown: "".concat(baseUrl, "badges/badge_crown.svg"),
    badgeDocument: "".concat(baseUrl, "badges/badge_document.svg"),
    badgeDocumentAdd: "".concat(baseUrl, "badges/badge_document_add.svg"),
    badgeDraft: "".concat(baseUrl, "badges/badge_draft.png"),
    badgeDraftHover: "".concat(baseUrl, "badges/badge_draft_hover.png"),
    badgeHouse: "".concat(baseUrl, "badges/badge_house.svg"),
    badgeOffice: "".concat(baseUrl, "badges/badge_office.svg"),
    badgePhone: "".concat(baseUrl, "badges/badge_phone.svg"),
    badgeSign: "".concat(baseUrl, "badges/badge_sign.png"),
    badgeSignHover: "".concat(baseUrl, "badges/badge_sign_hover.png"),
    badgeSupport: "".concat(baseUrl, "badges/badge_support.svg"),
    badgeTemplate: "".concat(baseUrl, "badges/badge_template.png"),
    badgeTemplateHover: "".concat(baseUrl, "badges/badge_template_hover.png"),
    badgeUpgrade: "".concat(baseUrl, "badges/badge_upgrade.png"),
    badgeUpgradeHover: "".concat(baseUrl, "badges/badge_upgrade_hover.png"),
    badgeUpload: "".concat(baseUrl, "badges/badge_upload.png"),
    badgeUploadHover: "".concat(baseUrl, "badges/badge_upload_hover.png"),
    badgeUser: "".concat(baseUrl, "badges/badge_user.svg"),
    badgeUserPlaceholder: "".concat(baseUrl, "badges/badge_user_placeholder.svg"),
    badgeUsers: "".concat(baseUrl, "badges/badge_users.svg"),
    planbadgeBusinesspro: "".concat(baseUrl, "badges/planbadge_businesspro.svg"),
    planbadgeDeveloper: "".concat(baseUrl, "badges/planbadge_developer.svg"),
    planbadgeEnterprisepro: "".concat(baseUrl, "badges/planbadge_enterprisepro.svg"),
    planbadgeFree: "".concat(baseUrl, "badges/planbadge_free.svg"),
    planbadgePersonal: "".concat(baseUrl, "badges/planbadge_personal.svg"),
    planbadgeRealestate: "".concat(baseUrl, "badges/planbadge_realestate.svg"),
    planbadgeStandard: "".concat(baseUrl, "badges/planbadge_standard.svg"),
    bgHeroMyAccount: "".concat(baseUrl, "bg-hero-my-account.png"),
    bgHero: "".concat(baseUrl, "bg-hero.png"),
    close: "".concat(baseUrl, "close.svg"),
    docusignAppLogoAdmin: "".concat(baseUrl, "docusign-app-logos/docusignAppLogoAdmin.svg"),
    docusignAppLogoClm: "".concat(baseUrl, "docusign-app-logos/docusignAppLogoClm.svg"),
    docusignAppLogoDtr: "".concat(baseUrl, "docusign-app-logos/docusignAppLogoDtr.svg"),
    docusignAppLogoEsign: "".concat(baseUrl, "docusign-app-logos/docusignAppLogoEsign.svg"),
    logoAndNameAdmin: "".concat(baseUrl, "docusign-app-logos/logoAndNameAdmin.svg"),
    logoAndNameAdmin2: "".concat(baseUrl, "docusign-app-logos/logoAndNameAdmin2.svg"),
    logoAndNameClm: "".concat(baseUrl, "docusign-app-logos/logoAndNameCLM.svg"),
    logoAndNameDtr: "".concat(baseUrl, "docusign-app-logos/logoAndNameDTR.svg"),
    logoAndNameESign: "".concat(baseUrl, "docusign-app-logos/logoAndNameESign.svg"),
    logoAndNameInsight: "".concat(baseUrl, "docusign-app-logos/logoAndNameInsight.svg"),
    logoAndNameInsightBlack: "".concat(baseUrl, "docusign-app-logos/logoAndNameInsightBlack.svg"),
    logoAndNameNonProduct: "".concat(baseUrl, "docusign-app-logos/logoAndNameNonProduct.svg"),
    logoAndNameSeal: "".concat(baseUrl, "docusign-app-logos/logoAndNameSeal.svg"),
    easySignAddUserIcon: "".concat(baseUrl, "easy-sign/easySignAddUserIcon.svg"),
    easySignAdminAvatar: "".concat(baseUrl, "easy-sign/easySignAdminAvatar.svg"),
    easySignAmexLogo: "".concat(baseUrl, "easy-sign/easySignAmexLogo.svg"),
    easySignCheckmark: "".concat(baseUrl, "easy-sign/easySignCheckmark.gif"),
    easySignCustomAvatar: "".concat(baseUrl, "easy-sign/easySignCustomAvatar.svg"),
    easySignDirectDebitLogo: "".concat(baseUrl, "easy-sign/easySignDirectDebitLogo.svg"),
    easySignMastercardLogo: "".concat(baseUrl, "easy-sign/easySignMastercardLogo.svg"),
    easySignPaypalLogo: "".concat(baseUrl, "easy-sign/easySignPaypalLogo.svg"),
    easySignSenderAvatar: "".concat(baseUrl, "easy-sign/easySignSenderAvatar.svg"),
    easySignSepaLogo: "".concat(baseUrl, "easy-sign/easySignSepaLogo.svg"),
    easySignViewerAvatar: "".concat(baseUrl, "easy-sign/easySignViewerAvatar.svg"),
    easySignVisaLogo: "".concat(baseUrl, "easy-sign/easySignVisaLogo.svg"),
    freeTrialModalRightPanelActivation: "".concat(baseUrl, "ecom/freeTrialModalRightPanelActivation.svg"),
    freeTrialModalRightPanelEmail: "".concat(baseUrl, "ecom/freeTrialModalRightPanelEmail.svg"),
    iconAlertDiamond: "".concat(baseUrl, "email/iconAlertDiamond.png"),
    iconDoorAdd: "".concat(baseUrl, "email/iconDoorAdd.png"),
    iconFile: "".concat(baseUrl, "email/iconFile.png"),
    iconFileWithCheck: "".concat(baseUrl, "email/iconFileWithCheck.png"),
    iconFileWithX: "".concat(baseUrl, "email/iconFileWithX.png"),
    iconHome: "".concat(baseUrl, "email/iconHome.png"),
    iconLockClosed: "".concat(baseUrl, "email/iconLockClosed.png"),
    iconLockOpen: "".concat(baseUrl, "email/iconLockOpen.png"),
    iconNotification: "".concat(baseUrl, "email/iconNotification.png"),
    iconPayment: "".concat(baseUrl, "email/iconPayment.png"),
    iconPaymentAlert: "".concat(baseUrl, "email/iconPaymentAlert.png"),
    iconPerson: "".concat(baseUrl, "email/iconPerson.png"),
    iconPersonAdd: "".concat(baseUrl, "email/iconPersonAdd.png"),
    iconShieldCheck: "".concat(baseUrl, "email/iconShieldCheck.png"),
    iconSign: "".concat(baseUrl, "email/iconSign.png"),
    agreementsEmptyState: "".concat(baseUrl, "empty-state/agreements-empty-state.svg"),
    emptyStateBulkSend: "".concat(baseUrl, "empty-state/emptyStateBulkSend.svg"),
    emptyStateFavoriteTemplate: "".concat(baseUrl, "empty-state/emptyStateFavoriteTemplate.svg"),
    emptyStateInbox: "".concat(baseUrl, "empty-state/emptyStateInbox.svg"),
    emptyStateManageBgd: "".concat(baseUrl, "empty-state/emptyStateManageBgd.svg"),
    emptyStatePowerForms: "".concat(baseUrl, "empty-state/emptyStatePowerForms.svg"),
    emptyStateSent: "".concat(baseUrl, "empty-state/emptyStateSent.svg"),
    emptyStateTemplate: "".concat(baseUrl, "empty-state/emptyStateTemplate.svg"),
    emptyStateWebForms: "".concat(baseUrl, "empty-state/emptyStateWebForms.svg"),
    androidChrome_192x192: "".concat(baseUrl, "favicons/android-chrome-192x192.png"),
    androidChrome_512x512: "".concat(baseUrl, "favicons/android-chrome-512x512.png"),
    appleTouchIcon: "".concat(baseUrl, "favicons/apple-touch-icon.png"),
    favicon_16x16: "".concat(baseUrl, "favicons/favicon-16x16.png"),
    favicon_32x32: "".concat(baseUrl, "favicons/favicon-32x32.png"),
    favicon: "".concat(baseUrl, "favicons/favicon.ico"),
    mstile_144x144: "".concat(baseUrl, "favicons/mstile-144x144.png"),
    mstile_150x150: "".concat(baseUrl, "favicons/mstile-150x150.png"),
    mstile_310x150: "".concat(baseUrl, "favicons/mstile-310x150.png"),
    mstile_310x310: "".concat(baseUrl, "favicons/mstile-310x310.png"),
    mstile_70x70: "".concat(baseUrl, "favicons/mstile-70x70.png"),
    safariPinnedTab: "".concat(baseUrl, "favicons/safari-pinned-tab.svg"),
    adminIdentityVerification: "".concat(baseUrl, "feature-wall/adminIdentityVerification.jpg"),
    adminSmSdelivery: "".concat(baseUrl, "feature-wall/adminSMSdelivery.png"),
    branding: "".concat(baseUrl, "ndse/branding.svg"),
    bulksend: "".concat(baseUrl, "feature-wall/bulksend.gif"),
    correct: "".concat(baseUrl, "feature-wall/correct.gif"),
    featureTrialModalIdentityVerificationDe: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification-de.jpg"),
    featureTrialModalIdentityVerificationEs: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification-es.jpg"),
    featureTrialModalIdentityVerificationFr: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification-fr.jpg"),
    featureTrialModalIdentityVerificationIt: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification-it.jpg"),
    featureTrialModalIdentityVerificationJa: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification-ja.jpg"),
    featureTrialModalIdentityVerificationKo: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification-ko.jpg"),
    featureTrialModalIdentityVerificationNl: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification-nl.jpg"),
    featureTrialModalIdentityVerificationPl: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification-pl.jpg"),
    featureTrialModalIdentityVerificationPt: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification-pt.jpg"),
    featureTrialModalIdentityVerificationPtBr: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification-pt_BR.jpg"),
    featureTrialModalIdentityVerificationRu: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification-ru.jpg"),
    featureTrialModalIdentityVerificationZhCn: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification-zh_CN.jpg"),
    featureTrialModalIdentityVerificationZhTw: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification-zh_TW.jpg"),
    featureTrialModalIdentityVerification: "".concat(baseUrl, "feature-wall/featureTrialModalIdentityVerification.jpg"),
    featureTrialModalSmSdeliveryDe: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery-de.png"),
    featureTrialModalSmSdeliveryEs: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery-es.png"),
    featureTrialModalSmSdeliveryFr: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery-fr.png"),
    featureTrialModalSmSdeliveryIt: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery-it.png"),
    featureTrialModalSmSdeliveryJa: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery-ja.png"),
    featureTrialModalSmSdeliveryKo: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery-ko.png"),
    featureTrialModalSmSdeliveryNl: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery-nl.png"),
    featureTrialModalSmSdeliveryPl: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery-pl.png"),
    featureTrialModalSmSdeliveryPt: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery-pt.png"),
    featureTrialModalSmSdeliveryPtBr: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery-pt_BR.png"),
    featureTrialModalSmSdeliveryRu: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery-ru.png"),
    featureTrialModalSmSdeliveryZhCn: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery-zh_CN.png"),
    featureTrialModalSmSdeliveryZhTw: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery-zh_TW.png"),
    featureTrialModalSmSdelivery: "".concat(baseUrl, "feature-wall/featureTrialModalSMSdelivery.png"),
    powerforms: "".concat(baseUrl, "feature-wall/powerforms.gif"),
    sidekickIdentityVerification: "".concat(baseUrl, "feature-wall/sidekickIdentityVerification.jpg"),
    sidekickSmSdelivery: "".concat(baseUrl, "feature-wall/sidekickSMSdelivery.png"),
    templates: "".concat(baseUrl, "feature-wall/templates.gif"),
    "default": "".concat(baseUrl, "file-types/default.svg"),
    documentCsv_2x: "".concat(baseUrl, "file-types/document_CSV@2x.png"),
    documentDoc_2x: "".concat(baseUrl, "file-types/document_DOC@2x.png"),
    documentDocx_2x: "".concat(baseUrl, "file-types/document_DOCX@2x.png"),
    documentGif_2x: "".concat(baseUrl, "file-types/document_GIF@2x.png"),
    documentJpeg_2x: "".concat(baseUrl, "file-types/document_JPEG@2x.png"),
    documentJpg_2x: "".concat(baseUrl, "file-types/document_JPG@2x.png"),
    documentNone_2x: "".concat(baseUrl, "file-types/document_None@2x.png"),
    documentPdf_2x: "".concat(baseUrl, "file-types/document_PDF@2x.png"),
    documentPng_2x: "".concat(baseUrl, "file-types/document_PNG@2x.png"),
    documentPpt_2x: "".concat(baseUrl, "file-types/document_PPT@2x.png"),
    documentPptx_2x: "".concat(baseUrl, "file-types/document_PPTX@2x.png"),
    documentRtf_2x: "".concat(baseUrl, "file-types/document_RTF@2x.png"),
    documentTif_2x: "".concat(baseUrl, "file-types/document_TIF@2x.png"),
    documentTiff_2x: "".concat(baseUrl, "file-types/document_TIFF@2x.png"),
    documentTxt_2x: "".concat(baseUrl, "file-types/document_TXT@2x.png"),
    documentUnknown_2x: "".concat(baseUrl, "file-types/document_Unknown@2x.png"),
    documentXls_2x: "".concat(baseUrl, "file-types/document_XLS@2x.png"),
    documentXlsx_2x: "".concat(baseUrl, "file-types/document_XLSX@2x.png"),
    folder: "".concat(baseUrl, "file-types/folder.svg"),
    image: "".concat(baseUrl, "file-types/image.svg"),
    pdf: "".concat(baseUrl, "file-types/pdf.svg"),
    presentation: "".concat(baseUrl, "file-types/presentation.svg"),
    spreadsheet: "".concat(baseUrl, "file-types/spreadsheet.svg"),
    text: "".concat(baseUrl, "file-types/text.svg"),
    unknown: "".concat(baseUrl, "file-types/unknown.svg"),
    unsupported: "".concat(baseUrl, "file-types/unsupported.svg"),
    flagAc: "".concat(baseUrl, "flags/flag-ac.svg"),
    flagAd: "".concat(baseUrl, "flags/flag-ad.svg"),
    flagAe: "".concat(baseUrl, "flags/flag-ae.svg"),
    flagAf: "".concat(baseUrl, "flags/flag-af.svg"),
    flagAg: "".concat(baseUrl, "flags/flag-ag.svg"),
    flagAi: "".concat(baseUrl, "flags/flag-ai.svg"),
    flagAl: "".concat(baseUrl, "flags/flag-al.svg"),
    flagAm: "".concat(baseUrl, "flags/flag-am.svg"),
    flagAo: "".concat(baseUrl, "flags/flag-ao.svg"),
    flagAq: "".concat(baseUrl, "flags/flag-aq.svg"),
    flagAr: "".concat(baseUrl, "flags/flag-ar.svg"),
    flagAs: "".concat(baseUrl, "flags/flag-as.svg"),
    flagAt: "".concat(baseUrl, "flags/flag-at.svg"),
    flagAu: "".concat(baseUrl, "flags/flag-au.svg"),
    flagAw: "".concat(baseUrl, "flags/flag-aw.svg"),
    flagAx: "".concat(baseUrl, "flags/flag-ax.svg"),
    flagAz: "".concat(baseUrl, "flags/flag-az.svg"),
    flagBa: "".concat(baseUrl, "flags/flag-ba.svg"),
    flagBb: "".concat(baseUrl, "flags/flag-bb.svg"),
    flagBd: "".concat(baseUrl, "flags/flag-bd.svg"),
    flagBe: "".concat(baseUrl, "flags/flag-be.svg"),
    flagBf: "".concat(baseUrl, "flags/flag-bf.svg"),
    flagBg: "".concat(baseUrl, "flags/flag-bg.svg"),
    flagBh: "".concat(baseUrl, "flags/flag-bh.svg"),
    flagBi: "".concat(baseUrl, "flags/flag-bi.svg"),
    flagBj: "".concat(baseUrl, "flags/flag-bj.svg"),
    flagBl: "".concat(baseUrl, "flags/flag-bl.svg"),
    flagBm: "".concat(baseUrl, "flags/flag-bm.svg"),
    flagBn: "".concat(baseUrl, "flags/flag-bn.svg"),
    flagBo: "".concat(baseUrl, "flags/flag-bo.svg"),
    flagBq: "".concat(baseUrl, "flags/flag-bq.svg"),
    flagBr: "".concat(baseUrl, "flags/flag-br.svg"),
    flagBs: "".concat(baseUrl, "flags/flag-bs.svg"),
    flagBt: "".concat(baseUrl, "flags/flag-bt.svg"),
    flagBv: "".concat(baseUrl, "flags/flag-bv.svg"),
    flagBw: "".concat(baseUrl, "flags/flag-bw.svg"),
    flagBy: "".concat(baseUrl, "flags/flag-by.svg"),
    flagBz: "".concat(baseUrl, "flags/flag-bz.svg"),
    flagCa: "".concat(baseUrl, "flags/flag-ca.svg"),
    flagCc: "".concat(baseUrl, "flags/flag-cc.svg"),
    flagCd: "".concat(baseUrl, "flags/flag-cd.svg"),
    flagCefta: "".concat(baseUrl, "flags/flag-cefta.svg"),
    flagCf: "".concat(baseUrl, "flags/flag-cf.svg"),
    flagCg: "".concat(baseUrl, "flags/flag-cg.svg"),
    flagCh: "".concat(baseUrl, "flags/flag-ch.svg"),
    flagCi: "".concat(baseUrl, "flags/flag-ci.svg"),
    flagCk: "".concat(baseUrl, "flags/flag-ck.svg"),
    flagCl: "".concat(baseUrl, "flags/flag-cl.svg"),
    flagCm: "".concat(baseUrl, "flags/flag-cm.svg"),
    flagCn: "".concat(baseUrl, "flags/flag-cn.svg"),
    flagCo: "".concat(baseUrl, "flags/flag-co.svg"),
    flagCp: "".concat(baseUrl, "flags/flag-cp.svg"),
    flagCr: "".concat(baseUrl, "flags/flag-cr.svg"),
    flagCu: "".concat(baseUrl, "flags/flag-cu.svg"),
    flagCv: "".concat(baseUrl, "flags/flag-cv.svg"),
    flagCw: "".concat(baseUrl, "flags/flag-cw.svg"),
    flagCx: "".concat(baseUrl, "flags/flag-cx.svg"),
    flagCy: "".concat(baseUrl, "flags/flag-cy.svg"),
    flagCz: "".concat(baseUrl, "flags/flag-cz.svg"),
    flagDe: "".concat(baseUrl, "flags/flag-de.svg"),
    flagDg: "".concat(baseUrl, "flags/flag-dg.svg"),
    flagDj: "".concat(baseUrl, "flags/flag-dj.svg"),
    flagDk: "".concat(baseUrl, "flags/flag-dk.svg"),
    flagDm: "".concat(baseUrl, "flags/flag-dm.svg"),
    flagDo: "".concat(baseUrl, "flags/flag-do.svg"),
    flagDz: "".concat(baseUrl, "flags/flag-dz.svg"),
    flagEa: "".concat(baseUrl, "flags/flag-ea.svg"),
    flagEc: "".concat(baseUrl, "flags/flag-ec.svg"),
    flagEe: "".concat(baseUrl, "flags/flag-ee.svg"),
    flagEg: "".concat(baseUrl, "flags/flag-eg.svg"),
    flagEh: "".concat(baseUrl, "flags/flag-eh.svg"),
    flagEr: "".concat(baseUrl, "flags/flag-er.svg"),
    flagEsCt: "".concat(baseUrl, "flags/flag-es-ct.svg"),
    flagEsGa: "".concat(baseUrl, "flags/flag-es-ga.svg"),
    flagEs: "".concat(baseUrl, "flags/flag-es.svg"),
    flagEt: "".concat(baseUrl, "flags/flag-et.svg"),
    flagEu: "".concat(baseUrl, "flags/flag-eu.svg"),
    flagFi: "".concat(baseUrl, "flags/flag-fi.svg"),
    flagFj: "".concat(baseUrl, "flags/flag-fj.svg"),
    flagFk: "".concat(baseUrl, "flags/flag-fk.svg"),
    flagFm: "".concat(baseUrl, "flags/flag-fm.svg"),
    flagFo: "".concat(baseUrl, "flags/flag-fo.svg"),
    flagFr: "".concat(baseUrl, "flags/flag-fr.svg"),
    flagGa: "".concat(baseUrl, "flags/flag-ga.svg"),
    flagGbEng: "".concat(baseUrl, "flags/flag-gb-eng.svg"),
    flagGbNir: "".concat(baseUrl, "flags/flag-gb-nir.svg"),
    flagGbSct: "".concat(baseUrl, "flags/flag-gb-sct.svg"),
    flagGbWls: "".concat(baseUrl, "flags/flag-gb-wls.svg"),
    flagGb: "".concat(baseUrl, "flags/flag-gb.svg"),
    flagGd: "".concat(baseUrl, "flags/flag-gd.svg"),
    flagGe: "".concat(baseUrl, "flags/flag-ge.svg"),
    flagGf: "".concat(baseUrl, "flags/flag-gf.svg"),
    flagGg: "".concat(baseUrl, "flags/flag-gg.svg"),
    flagGh: "".concat(baseUrl, "flags/flag-gh.svg"),
    flagGi: "".concat(baseUrl, "flags/flag-gi.svg"),
    flagGl: "".concat(baseUrl, "flags/flag-gl.svg"),
    flagGm: "".concat(baseUrl, "flags/flag-gm.svg"),
    flagGn: "".concat(baseUrl, "flags/flag-gn.svg"),
    flagGp: "".concat(baseUrl, "flags/flag-gp.svg"),
    flagGq: "".concat(baseUrl, "flags/flag-gq.svg"),
    flagGr: "".concat(baseUrl, "flags/flag-gr.svg"),
    flagGs: "".concat(baseUrl, "flags/flag-gs.svg"),
    flagGt: "".concat(baseUrl, "flags/flag-gt.svg"),
    flagGu: "".concat(baseUrl, "flags/flag-gu.svg"),
    flagGw: "".concat(baseUrl, "flags/flag-gw.svg"),
    flagGy: "".concat(baseUrl, "flags/flag-gy.svg"),
    flagHk: "".concat(baseUrl, "flags/flag-hk.svg"),
    flagHm: "".concat(baseUrl, "flags/flag-hm.svg"),
    flagHn: "".concat(baseUrl, "flags/flag-hn.svg"),
    flagHr: "".concat(baseUrl, "flags/flag-hr.svg"),
    flagHt: "".concat(baseUrl, "flags/flag-ht.svg"),
    flagHu: "".concat(baseUrl, "flags/flag-hu.svg"),
    flagIc: "".concat(baseUrl, "flags/flag-ic.svg"),
    flagId: "".concat(baseUrl, "flags/flag-id.svg"),
    flagIe: "".concat(baseUrl, "flags/flag-ie.svg"),
    flagIl: "".concat(baseUrl, "flags/flag-il.svg"),
    flagIm: "".concat(baseUrl, "flags/flag-im.svg"),
    flagIn: "".concat(baseUrl, "flags/flag-in.svg"),
    flagIo: "".concat(baseUrl, "flags/flag-io.svg"),
    flagIq: "".concat(baseUrl, "flags/flag-iq.svg"),
    flagIr: "".concat(baseUrl, "flags/flag-ir.svg"),
    flagIs: "".concat(baseUrl, "flags/flag-is.svg"),
    flagIt: "".concat(baseUrl, "flags/flag-it.svg"),
    flagJe: "".concat(baseUrl, "flags/flag-je.svg"),
    flagJm: "".concat(baseUrl, "flags/flag-jm.svg"),
    flagJo: "".concat(baseUrl, "flags/flag-jo.svg"),
    flagJp: "".concat(baseUrl, "flags/flag-jp.svg"),
    flagKe: "".concat(baseUrl, "flags/flag-ke.svg"),
    flagKg: "".concat(baseUrl, "flags/flag-kg.svg"),
    flagKh: "".concat(baseUrl, "flags/flag-kh.svg"),
    flagKi: "".concat(baseUrl, "flags/flag-ki.svg"),
    flagKm: "".concat(baseUrl, "flags/flag-km.svg"),
    flagKn: "".concat(baseUrl, "flags/flag-kn.svg"),
    flagKp: "".concat(baseUrl, "flags/flag-kp.svg"),
    flagKr: "".concat(baseUrl, "flags/flag-kr.svg"),
    flagKw: "".concat(baseUrl, "flags/flag-kw.svg"),
    flagKy: "".concat(baseUrl, "flags/flag-ky.svg"),
    flagKz: "".concat(baseUrl, "flags/flag-kz.svg"),
    flagLa: "".concat(baseUrl, "flags/flag-la.svg"),
    flagLb: "".concat(baseUrl, "flags/flag-lb.svg"),
    flagLc: "".concat(baseUrl, "flags/flag-lc.svg"),
    flagLi: "".concat(baseUrl, "flags/flag-li.svg"),
    flagLk: "".concat(baseUrl, "flags/flag-lk.svg"),
    flagLr: "".concat(baseUrl, "flags/flag-lr.svg"),
    flagLs: "".concat(baseUrl, "flags/flag-ls.svg"),
    flagLt: "".concat(baseUrl, "flags/flag-lt.svg"),
    flagLu: "".concat(baseUrl, "flags/flag-lu.svg"),
    flagLv: "".concat(baseUrl, "flags/flag-lv.svg"),
    flagLy: "".concat(baseUrl, "flags/flag-ly.svg"),
    flagMa: "".concat(baseUrl, "flags/flag-ma.svg"),
    flagMc: "".concat(baseUrl, "flags/flag-mc.svg"),
    flagMd: "".concat(baseUrl, "flags/flag-md.svg"),
    flagMe: "".concat(baseUrl, "flags/flag-me.svg"),
    flagMf: "".concat(baseUrl, "flags/flag-mf.svg"),
    flagMg: "".concat(baseUrl, "flags/flag-mg.svg"),
    flagMh: "".concat(baseUrl, "flags/flag-mh.svg"),
    flagMk: "".concat(baseUrl, "flags/flag-mk.svg"),
    flagMl: "".concat(baseUrl, "flags/flag-ml.svg"),
    flagMm: "".concat(baseUrl, "flags/flag-mm.svg"),
    flagMn: "".concat(baseUrl, "flags/flag-mn.svg"),
    flagMo: "".concat(baseUrl, "flags/flag-mo.svg"),
    flagMp: "".concat(baseUrl, "flags/flag-mp.svg"),
    flagMq: "".concat(baseUrl, "flags/flag-mq.svg"),
    flagMr: "".concat(baseUrl, "flags/flag-mr.svg"),
    flagMs: "".concat(baseUrl, "flags/flag-ms.svg"),
    flagMt: "".concat(baseUrl, "flags/flag-mt.svg"),
    flagMu: "".concat(baseUrl, "flags/flag-mu.svg"),
    flagMv: "".concat(baseUrl, "flags/flag-mv.svg"),
    flagMw: "".concat(baseUrl, "flags/flag-mw.svg"),
    flagMx: "".concat(baseUrl, "flags/flag-mx.svg"),
    flagMy: "".concat(baseUrl, "flags/flag-my.svg"),
    flagMz: "".concat(baseUrl, "flags/flag-mz.svg"),
    flagNa: "".concat(baseUrl, "flags/flag-na.svg"),
    flagNc: "".concat(baseUrl, "flags/flag-nc.svg"),
    flagNe: "".concat(baseUrl, "flags/flag-ne.svg"),
    flagNf: "".concat(baseUrl, "flags/flag-nf.svg"),
    flagNg: "".concat(baseUrl, "flags/flag-ng.svg"),
    flagNi: "".concat(baseUrl, "flags/flag-ni.svg"),
    flagNl: "".concat(baseUrl, "flags/flag-nl.svg"),
    flagNo: "".concat(baseUrl, "flags/flag-no.svg"),
    flagNp: "".concat(baseUrl, "flags/flag-np.svg"),
    flagNr: "".concat(baseUrl, "flags/flag-nr.svg"),
    flagNu: "".concat(baseUrl, "flags/flag-nu.svg"),
    flagNz: "".concat(baseUrl, "flags/flag-nz.svg"),
    flagOm: "".concat(baseUrl, "flags/flag-om.svg"),
    flagPa: "".concat(baseUrl, "flags/flag-pa.svg"),
    flagPe: "".concat(baseUrl, "flags/flag-pe.svg"),
    flagPf: "".concat(baseUrl, "flags/flag-pf.svg"),
    flagPg: "".concat(baseUrl, "flags/flag-pg.svg"),
    flagPh: "".concat(baseUrl, "flags/flag-ph.svg"),
    flagPk: "".concat(baseUrl, "flags/flag-pk.svg"),
    flagPl: "".concat(baseUrl, "flags/flag-pl.svg"),
    flagPm: "".concat(baseUrl, "flags/flag-pm.svg"),
    flagPn: "".concat(baseUrl, "flags/flag-pn.svg"),
    flagPr: "".concat(baseUrl, "flags/flag-pr.svg"),
    flagPs: "".concat(baseUrl, "flags/flag-ps.svg"),
    flagPt: "".concat(baseUrl, "flags/flag-pt.svg"),
    flagPw: "".concat(baseUrl, "flags/flag-pw.svg"),
    flagPy: "".concat(baseUrl, "flags/flag-py.svg"),
    flagQa: "".concat(baseUrl, "flags/flag-qa.svg"),
    flagRe: "".concat(baseUrl, "flags/flag-re.svg"),
    flagRo: "".concat(baseUrl, "flags/flag-ro.svg"),
    flagRs: "".concat(baseUrl, "flags/flag-rs.svg"),
    flagRu: "".concat(baseUrl, "flags/flag-ru.svg"),
    flagRw: "".concat(baseUrl, "flags/flag-rw.svg"),
    flagSa: "".concat(baseUrl, "flags/flag-sa.svg"),
    flagSb: "".concat(baseUrl, "flags/flag-sb.svg"),
    flagSc: "".concat(baseUrl, "flags/flag-sc.svg"),
    flagSd: "".concat(baseUrl, "flags/flag-sd.svg"),
    flagSe: "".concat(baseUrl, "flags/flag-se.svg"),
    flagSg: "".concat(baseUrl, "flags/flag-sg.svg"),
    flagSh: "".concat(baseUrl, "flags/flag-sh.svg"),
    flagSi: "".concat(baseUrl, "flags/flag-si.svg"),
    flagSj: "".concat(baseUrl, "flags/flag-sj.svg"),
    flagSk: "".concat(baseUrl, "flags/flag-sk.svg"),
    flagSl: "".concat(baseUrl, "flags/flag-sl.svg"),
    flagSm: "".concat(baseUrl, "flags/flag-sm.svg"),
    flagSn: "".concat(baseUrl, "flags/flag-sn.svg"),
    flagSo: "".concat(baseUrl, "flags/flag-so.svg"),
    flagSr: "".concat(baseUrl, "flags/flag-sr.svg"),
    flagSs: "".concat(baseUrl, "flags/flag-ss.svg"),
    flagSt: "".concat(baseUrl, "flags/flag-st.svg"),
    flagSv: "".concat(baseUrl, "flags/flag-sv.svg"),
    flagSx: "".concat(baseUrl, "flags/flag-sx.svg"),
    flagSy: "".concat(baseUrl, "flags/flag-sy.svg"),
    flagSz: "".concat(baseUrl, "flags/flag-sz.svg"),
    flagTa: "".concat(baseUrl, "flags/flag-ta.svg"),
    flagTc: "".concat(baseUrl, "flags/flag-tc.svg"),
    flagTd: "".concat(baseUrl, "flags/flag-td.svg"),
    flagTf: "".concat(baseUrl, "flags/flag-tf.svg"),
    flagTg: "".concat(baseUrl, "flags/flag-tg.svg"),
    flagTh: "".concat(baseUrl, "flags/flag-th.svg"),
    flagTj: "".concat(baseUrl, "flags/flag-tj.svg"),
    flagTk: "".concat(baseUrl, "flags/flag-tk.svg"),
    flagTl: "".concat(baseUrl, "flags/flag-tl.svg"),
    flagTm: "".concat(baseUrl, "flags/flag-tm.svg"),
    flagTn: "".concat(baseUrl, "flags/flag-tn.svg"),
    flagTo: "".concat(baseUrl, "flags/flag-to.svg"),
    flagTr: "".concat(baseUrl, "flags/flag-tr.svg"),
    flagTt: "".concat(baseUrl, "flags/flag-tt.svg"),
    flagTv: "".concat(baseUrl, "flags/flag-tv.svg"),
    flagTw: "".concat(baseUrl, "flags/flag-tw.svg"),
    flagTz: "".concat(baseUrl, "flags/flag-tz.svg"),
    flagUa: "".concat(baseUrl, "flags/flag-ua.svg"),
    flagUg: "".concat(baseUrl, "flags/flag-ug.svg"),
    flagUm: "".concat(baseUrl, "flags/flag-um.svg"),
    flagUn: "".concat(baseUrl, "flags/flag-un.svg"),
    flagUs: "".concat(baseUrl, "flags/flag-us.svg"),
    flagUy: "".concat(baseUrl, "flags/flag-uy.svg"),
    flagUz: "".concat(baseUrl, "flags/flag-uz.svg"),
    flagVa: "".concat(baseUrl, "flags/flag-va.svg"),
    flagVc: "".concat(baseUrl, "flags/flag-vc.svg"),
    flagVe: "".concat(baseUrl, "flags/flag-ve.svg"),
    flagVg: "".concat(baseUrl, "flags/flag-vg.svg"),
    flagVi: "".concat(baseUrl, "flags/flag-vi.svg"),
    flagVn: "".concat(baseUrl, "flags/flag-vn.svg"),
    flagVu: "".concat(baseUrl, "flags/flag-vu.svg"),
    flagWf: "".concat(baseUrl, "flags/flag-wf.svg"),
    flagWs: "".concat(baseUrl, "flags/flag-ws.svg"),
    flagXk: "".concat(baseUrl, "flags/flag-xk.svg"),
    flagXx: "".concat(baseUrl, "flags/flag-xx.svg"),
    flagYe: "".concat(baseUrl, "flags/flag-ye.svg"),
    flagYt: "".concat(baseUrl, "flags/flag-yt.svg"),
    flagZa: "".concat(baseUrl, "flags/flag-za.svg"),
    flagZm: "".concat(baseUrl, "flags/flag-zm.svg"),
    flagZw: "".concat(baseUrl, "flags/flag-zw.svg"),
    dsIconFaviconLight_16x16: "".concat(baseUrl, "global-assets/ds-icon-favicon-light-16x16.svg"),
    dsIconFaviconLight_24x24: "".concat(baseUrl, "global-assets/ds-icon-favicon-light-24x24.svg"),
    dsIconFaviconLight_32x32: "".concat(baseUrl, "global-assets/ds-icon-favicon-light-32x32.svg"),
    dsIconFaviconLight_64x64: "".concat(baseUrl, "global-assets/ds-icon-favicon-light-64x64.svg"),
    dsIconFaviconLight_80x80: "".concat(baseUrl, "global-assets/ds-icon-favicon-light-80x80.svg"),
    dsIconsFaviconDefault_16x16: "".concat(baseUrl, "global-assets/ds-icons-favicon-default-16x16.svg"),
    dsIconsFaviconDefault_24x24: "".concat(baseUrl, "global-assets/ds-icons-favicon-default-24x24.svg"),
    dsIconsFaviconDefault_32x32: "".concat(baseUrl, "global-assets/ds-icons-favicon-default-32x32.svg"),
    dsIconsFaviconDefault_64x64: "".concat(baseUrl, "global-assets/ds-icons-favicon-default-64x64.svg"),
    dsIconsFaviconDefault_80x80: "".concat(baseUrl, "global-assets/ds-icons-favicon-default-80x80.svg"),
    dsLogoDefault: "".concat(baseUrl, "global-assets/ds-logo-default.svg"),
    dsLogoDeveloperDefault: "".concat(baseUrl, "global-assets/ds-logo-developer-default.svg"),
    dsLogoInverse: "".concat(baseUrl, "global-assets/ds-logo-inverse.svg"),
    emailLogoWhite: "".concat(baseUrl, "global-assets/email-templates/email-logo-white.png"),
    emailLogo: "".concat(baseUrl, "global-assets/email-templates/email-logo.png"),
    iconDownloadApp: "".concat(baseUrl, "global-assets/email-templates/icon-download-app.png"),
    carbonCloud: "".concat(baseUrl, "green-score/carbonCloud.svg"),
    greenScoreLogo: "".concat(baseUrl, "green-score/greenScoreLogo.svg"),
    pineTree: "".concat(baseUrl, "green-score/pineTree.svg"),
    trashBin: "".concat(baseUrl, "green-score/trashBin.svg"),
    waterDrop: "".concat(baseUrl, "green-score/waterDrop.svg"),
    docusign: "".concat(baseUrl, "header-logos/docusign.svg"),
    docusignAdmin: "".concat(baseUrl, "header-logos/docusignAdmin.svg"),
    docusignClm: "".concat(baseUrl, "header-logos/docusignCLM.svg"),
    docusignDtr: "".concat(baseUrl, "header-logos/docusignDTR.svg"),
    docusignESign: "".concat(baseUrl, "header-logos/docusignESign.svg"),
    docusignInsight: "".concat(baseUrl, "header-logos/docusignInsight.svg"),
    barcodeGhostLandscape: "".concat(baseUrl, "identity/barcode-ghost-landscape.png"),
    barcodeGhostPortrait: "".concat(baseUrl, "identity/barcode-ghost-portrait.png"),
    disconnection: "".concat(baseUrl, "identity/disconnection.svg"),
    franceconnectBouton: "".concat(baseUrl, "identity/franceconnectBouton.svg"),
    franceconnectBoutonHover: "".concat(baseUrl, "identity/franceconnectBoutonHover.svg"),
    idcardDesktopBack: "".concat(baseUrl, "identity/idcard-desktop-back.png"),
    idcardDesktopFront: "".concat(baseUrl, "identity/idcard-desktop-front.png"),
    idcardGhostLandscape: "".concat(baseUrl, "identity/idcard-ghost-landscape.png"),
    idcardGhostPortrait: "".concat(baseUrl, "identity/idcard-ghost-portrait.png"),
    idcardLaptopBack: "".concat(baseUrl, "identity/idcard-laptop-back.svg"),
    idcardLaptopFront: "".concat(baseUrl, "identity/idcard-laptop-front.svg"),
    idcardMobileBack: "".concat(baseUrl, "identity/idcard-mobile-back.png"),
    idcardMobileFront: "".concat(baseUrl, "identity/idcard-mobile-front.png"),
    idcardPhoneBack: "".concat(baseUrl, "identity/idcard-phone-back.svg"),
    idcardPhoneFront: "".concat(baseUrl, "identity/idcard-phone-front.svg"),
    idvLogoAuthentify: "".concat(baseUrl, "idv/IdvLogoAuthentify.svg"),
    idvLogoDigitalId: "".concat(baseUrl, "identity/idvLogoDigitalId.svg"),
    idvLogoFranceConnect: "".concat(baseUrl, "identity/idvLogoFranceConnect.svg"),
    idvPhotoidDesktopPassport: "".concat(baseUrl, "identity/idvPhotoidDesktopPassport.svg"),
    idvPhotoidDesktopPhotoidBack: "".concat(baseUrl, "identity/idvPhotoidDesktopPhotoidBack.svg"),
    idvPhotoidDesktopPhotoidFront: "".concat(baseUrl, "identity/idvPhotoidDesktopPhotoidFront.svg"),
    idvPhotoidHowtoDeskTopPassport: "".concat(baseUrl, "identity/idvPhotoidHowtoDeskTopPassport.png"),
    idvPhotoidHowtoDeskTopPhotoidBack: "".concat(baseUrl, "identity/idvPhotoidHowtoDeskTopPhotoidBack.png"),
    idvPhotoidHowtoDeskTopPhotoidFront: "".concat(baseUrl, "identity/idvPhotoidHowtoDeskTopPhotoidFront.png"),
    idvPhotoidHowtoMobilePassport: "".concat(baseUrl, "identity/idvPhotoidHowtoMobilePassport.png"),
    idvPhotoidHowtoMobilePhotoidBack: "".concat(baseUrl, "identity/idvPhotoidHowtoMobilePhotoidBack.png"),
    idvPhotoidHowtoMobilePhotoidFront: "".concat(baseUrl, "identity/idvPhotoidHowtoMobilePhotoidFront.png"),
    idvPhotoidMobilePassport: "".concat(baseUrl, "identity/idvPhotoidMobilePassport.svg"),
    idvPhotoidMobilePhotoidBack: "".concat(baseUrl, "identity/idvPhotoidMobilePhotoidBack.svg"),
    idvPhotoidMobilePhotoidFront: "".concat(baseUrl, "identity/idvPhotoidMobilePhotoidFront.svg"),
    idvPhotoidValidationNameMatching: "".concat(baseUrl, "identity/idvPhotoidValidationNameMatching.gif"),
    idvPhotoidValidationUpload: "".concat(baseUrl, "identity/idvPhotoidValidationUpload.gif"),
    idvPhotoidValidationVerification: "".concat(baseUrl, "identity/idvPhotoidValidationVerification.gif"),
    idvPhotoidValidationVerified: "".concat(baseUrl, "identity/idvPhotoidValidationVerified.gif"),
    idvSignerheldInstructions: "".concat(baseUrl, "identity/idvSignerheldInstructions.svg"),
    idvUserConsent: "".concat(baseUrl, "identity/idvUserConsent.svg"),
    manualReviewError: "".concat(baseUrl, "identity/manual-review-error.svg"),
    notificationSent: "".concat(baseUrl, "identity/notification-sent.svg"),
    passportDesktop: "".concat(baseUrl, "identity/passport-desktop.png"),
    passportGhostLandscape: "".concat(baseUrl, "identity/passport-ghost-landscape.png"),
    passportGhostPortrait: "".concat(baseUrl, "identity/passport-ghost-portrait.png"),
    passportLaptop: "".concat(baseUrl, "identity/passport-laptop.svg"),
    passportMobile: "".concat(baseUrl, "identity/passport-mobile.png"),
    passportPhone: "".concat(baseUrl, "identity/passport-phone.svg"),
    smartcard: "".concat(baseUrl, "identity/smartcard.svg"),
    verifyPhoneCall: "".concat(baseUrl, "identity/verifyPhoneCall.svg"),
    verifySms: "".concat(baseUrl, "identity/verifySms.svg"),
    idpDeviceAuthentication: "".concat(baseUrl, "idp/idpDeviceAuthentication.svg"),
    idpIdentityWallet: "".concat(baseUrl, "idp/idpIdentityWallet.svg"),
    idpIdentityWalletAnimated: "".concat(baseUrl, "idp/idpIdentityWalletAnimated.gif"),
    idpIdentityWalletClosed: "".concat(baseUrl, "idp/idpIdentityWalletClosed.svg"),
    idpWarning: "".concat(baseUrl, "idp/idpWarning.svg"),
    idvInkAnalyzingVideo: "".concat(baseUrl, "idv/IdvInkAnalyzingVideo.gif"),
    idvInkBlurGlare: "".concat(baseUrl, "idv/IdvInkBlurGlare.gif"),
    idvInkCheckingDates: "".concat(baseUrl, "idv/IdvInkCheckingDates.gif"),
    idvInkNameMatching: "".concat(baseUrl, "idv/IdvInkNameMatching.gif"),
    idvInkSecurityChecks: "".concat(baseUrl, "idv/IdvInkSecurityChecks.gif"),
    idvInkSuccess: "".concat(baseUrl, "idv/IdvInkSuccess.gif"),
    idvEmailNotification: "".concat(baseUrl, "idv/idvEmailNotification.svg"),
    idvHourGlass: "".concat(baseUrl, "idv/idvHourGlass.svg"),
    idvIconCamera: "".concat(baseUrl, "idv/idvIconCamera.svg"),
    idvIconFlip: "".concat(baseUrl, "idv/idvIconFlip.svg"),
    idvIconImageUpload: "".concat(baseUrl, "idv/idvIconImageUpload.svg"),
    idvIconPassport: "".concat(baseUrl, "idv/idvIconPassport.svg"),
    idvIconPhotoId: "".concat(baseUrl, "idv/idvIconPhotoId.svg"),
    idvIconPhotoIdBack: "".concat(baseUrl, "idv/idvIconPhotoIdBack.svg"),
    idvIconSmartCardEId: "".concat(baseUrl, "idv/idvIconSmartCardEId.svg"),
    idvInkIconCertificate: "".concat(baseUrl, "idv/idvInkIconCertificate.svg"),
    idvInkIconDrivingLicense: "".concat(baseUrl, "idv/idvInkIconDrivingLicense.svg"),
    idvInkIconNationalIdCard: "".concat(baseUrl, "idv/idvInkIconNationalIDCard.svg"),
    idvInkIconPassport: "".concat(baseUrl, "idv/idvInkIconPassport.svg"),
    idvInkIconPhotoId: "".concat(baseUrl, "idv/idvInkIconPhotoId.svg"),
    idvInkIconResidencePermit: "".concat(baseUrl, "idv/idvInkIconResidencePermit.svg"),
    idvInkKba: "".concat(baseUrl, "idv/idvInkKba.svg"),
    idvInkSmartcardCoverLarge: "".concat(baseUrl, "idv/idvInkSmartcardCoverLarge.svg"),
    idvInkSmartcardCoverSmall: "".concat(baseUrl, "idv/idvInkSmartcardCoverSmall.svg"),
    idvInstructionsPassportFrame: "".concat(baseUrl, "idv/idvInstructionsPassportFrame.png"),
    idvInstructionsPhotoIdBackFrame: "".concat(baseUrl, "idv/idvInstructionsPhotoIDBackFrame.png"),
    idvInstructionsPhotoIdFrontFrame: "".concat(baseUrl, "idv/idvInstructionsPhotoIDFrontFrame.png"),
    idvInstructionsPhotoIdBarcode: "".concat(baseUrl, "idv/idvInstructionsPhotoIdBarcode.svg"),
    idvKbaSuccess: "".concat(baseUrl, "idv/idvKbaSuccess.svg"),
    idvLogoBankIdMobNo: "".concat(baseUrl, "idv/idvLogoBankIdMobNo.png"),
    idvLogoBankIdNo: "".concat(baseUrl, "idv/idvLogoBankIdNo.png"),
    idvLogoBankIdNoIconOnly: "".concat(baseUrl, "idv/idvLogoBankIdNoIconOnly.png"),
    idvLogoBankIdSe: "".concat(baseUrl, "idv/idvLogoBankIdSe.svg"),
    idvLogoFinnishBank: "".concat(baseUrl, "idv/idvLogoFinnishBank.svg"),
    idvLogoFtn: "".concat(baseUrl, "idv/idvLogoFtn.png"),
    idvLogoFtnIconOnly: "".concat(baseUrl, "idv/idvLogoFtnIconOnly.png"),
    idvLogoIdIn: "".concat(baseUrl, "idv/idvLogoIdIn.svg"),
    idvLogoItsMe: "".concat(baseUrl, "idv/idvLogoItsMe.png"),
    idvLogoKba: "".concat(baseUrl, "idv/idvLogoKba.svg"),
    idvLogoMitId: "".concat(baseUrl, "idv/idvLogoMitID.svg"),
    idvLogoNemId: "".concat(baseUrl, "idv/idvLogoNemId.svg"),
    idvLogoOneId: "".concat(baseUrl, "idv/idvLogoOneID.svg"),
    idvLogoOtherCountry: "".concat(baseUrl, "idv/idvLogoOtherCountry.svg"),
    idvManualReviewAccepted: "".concat(baseUrl, "idv/idvManualReviewAccepted.svg"),
    idvManualReviewRejected: "".concat(baseUrl, "idv/idvManualReviewRejected.svg"),
    idvManuelReviewPending: "".concat(baseUrl, "idv/idvManuelReviewPending.svg"),
    idvNoIdentification: "".concat(baseUrl, "idv/idvNoIdentification.svg"),
    idvReAuthSuccess: "".concat(baseUrl, "idv/idvReAuthSuccess.svg"),
    idvSuccess: "".concat(baseUrl, "idv/idvSuccess.svg"),
    idvVerifiedMe: "".concat(baseUrl, "idv/idvVerifiedMe.svg"),
    anotherIcon: "".concat(baseUrl, "illustrations/another_icon.svg"),
    brandingIcon: "".concat(baseUrl, "illustrations/branding_icon.svg"),
    checklistBanner_320: "".concat(baseUrl, "illustrations/checklist_banner_320.svg"),
    checklistBanner_544: "".concat(baseUrl, "illustrations/checklist_banner_544.svg"),
    checklistBanner_768: "".concat(baseUrl, "illustrations/checklist_banner_768.svg"),
    clickwrap: "".concat(baseUrl, "illustrations/clickwrap.svg"),
    customizeTrial: "".concat(baseUrl, "illustrations/customize_trial.svg"),
    deviceMobileFrameDisabled: "".concat(baseUrl, "illustrations/device-mobile-frame-disabled.svg"),
    deviceMobileFrame: "".concat(baseUrl, "illustrations/device-mobile-frame.svg"),
    deviceMonitorFrame: "".concat(baseUrl, "illustrations/device-monitor-frame.svg"),
    deviceTabletFrame: "".concat(baseUrl, "illustrations/device-tablet-frame.svg"),
    emptyStateBulkRooms: "".concat(baseUrl, "illustrations/empty_state_bulk_rooms.svg"),
    fileAdd: "".concat(baseUrl, "illustrations/file-add.svg"),
    fileDrop: "".concat(baseUrl, "illustrations/file-drop.svg"),
    freeTrialHomeblue: "".concat(baseUrl, "illustrations/free-trial-homeblue.png"),
    getTheApp_150px: "".concat(baseUrl, "illustrations/get_the_app_150px.svg"),
    meerkatWelcome: "".concat(baseUrl, "illustrations/meerkat-welcome.svg"),
    ndseFunctionalEmptyState: "".concat(baseUrl, "illustrations/ndse-functional-emptyState.svg"),
    ndseFunctionalTemplates: "".concat(baseUrl, "illustrations/ndse-functional-templates.svg"),
    ndseGoToMobileApp: "".concat(baseUrl, "illustrations/ndse-go-to-mobile-app.svg"),
    ndseManage: "".concat(baseUrl, "illustrations/ndse-manage.svg"),
    ndseMe: "".concat(baseUrl, "illustrations/ndse-me.svg"),
    ndseOthers: "".concat(baseUrl, "illustrations/ndse-others.svg"),
    ndseOutOfSends: "".concat(baseUrl, "illustrations/ndse-out-of-sends.svg"),
    ndsePaidConversion: "".concat(baseUrl, "illustrations/ndse-paidConversion.svg"),
    ndsePaidTrial: "".concat(baseUrl, "illustrations/ndse-paidTrial.svg"),
    ndseSelected: "".concat(baseUrl, "illustrations/ndse-selected.svg"),
    ndseSendAnother: "".concat(baseUrl, "illustrations/ndse-send-another.png"),
    ndseSendDocuments: "".concat(baseUrl, "illustrations/ndse-send-documents.svg"),
    ndseTemplates: "".concat(baseUrl, "illustrations/ndse-templates.png"),
    ndseTryTemplates: "".concat(baseUrl, "illustrations/ndse-try-templates.svg"),
    ndseUpgrade: "".concat(baseUrl, "illustrations/ndse-upgrade.png"),
    ndseUseTemplates: "".concat(baseUrl, "illustrations/ndse-use-templates.svg"),
    ndseWelcome_2: "".concat(baseUrl, "illustrations/ndse-welcome-2.svg"),
    ndseWelcome: "".concat(baseUrl, "illustrations/ndse-welcome.svg"),
    ndseNoTemplates: "".concat(baseUrl, "illustrations/ndseNoTemplates.svg"),
    onTheGo: "".concat(baseUrl, "illustrations/onTheGo.svg"),
    onboardingModalBg_320: "".concat(baseUrl, "illustrations/onboarding_modal_bg_320.svg"),
    onboardingModalBg_544: "".concat(baseUrl, "illustrations/onboarding_modal_bg_544.svg"),
    onboardingModalBg_768: "".concat(baseUrl, "illustrations/onboarding_modal_bg_768.svg"),
    postSendingAddUser: "".concat(baseUrl, "illustrations/post_sending_add_user.svg"),
    postSendingBranding: "".concat(baseUrl, "illustrations/post_sending_branding.svg"),
    postSendingCelebration: "".concat(baseUrl, "illustrations/post_sending_celebration.svg"),
    postSendingCloudIntegrations: "".concat(baseUrl, "illustrations/post_sending_cloud_integrations.svg"),
    postSendingEmpty: "".concat(baseUrl, "illustrations/post_sending_empty.svg"),
    postSendingExceed: "".concat(baseUrl, "illustrations/post_sending_exceed.svg"),
    postSendingFavoriteTemplate: "".concat(baseUrl, "illustrations/post_sending_favorite_template.svg"),
    postSendingFavoriteTemplateTransparent: "".concat(baseUrl, "illustrations/post_sending_favorite_template_transparent.svg"),
    postSendingFirstsent: "".concat(baseUrl, "illustrations/post_sending_firstsent.svg"),
    postSendingFlying: "".concat(baseUrl, "illustrations/post_sending_flying.svg"),
    postSendingForest: "".concat(baseUrl, "illustrations/post_sending_forest.svg"),
    postSendingScale: "".concat(baseUrl, "illustrations/post_sending_scale.svg"),
    postSendingSend: "".concat(baseUrl, "illustrations/post_sending_send.svg"),
    postSendingTemplate: "".concat(baseUrl, "illustrations/post_sending_template.svg"),
    postSendingThumbnail: "".concat(baseUrl, "illustrations/post_sending_thumbnail.svg"),
    postSendingTrack: "".concat(baseUrl, "illustrations/post_sending_track.svg"),
    postSendingUpgrade: "".concat(baseUrl, "illustrations/post_sending_upgrade.svg"),
    postSendingUrgent: "".concat(baseUrl, "illustrations/post_sending_urgent.svg"),
    promoAddUser_100px: "".concat(baseUrl, "illustrations/promo_add_user_100px.svg"),
    promoAddUser_320px: "".concat(baseUrl, "illustrations/promo_add_user_320px.svg"),
    promoAddUser_544px: "".concat(baseUrl, "illustrations/promo_add_user_544px.svg"),
    promoAnother_100px: "".concat(baseUrl, "illustrations/promo_another_100px.svg"),
    promoAnother_320px: "".concat(baseUrl, "illustrations/promo_another_320px.svg"),
    promoAnother_544px: "".concat(baseUrl, "illustrations/promo_another_544px.svg"),
    promoApp_100px: "".concat(baseUrl, "illustrations/promo_app_100px.svg"),
    promoApp_320px: "".concat(baseUrl, "illustrations/promo_app_320px.svg"),
    promoApp_544px: "".concat(baseUrl, "illustrations/promo_app_544px.svg"),
    promoBanner: "".concat(baseUrl, "illustrations/promo_banner.svg"),
    promoBanner_320px: "".concat(baseUrl, "illustrations/promo_banner_320px.svg"),
    promoBanner_544px: "".concat(baseUrl, "illustrations/promo_banner_544px.svg"),
    promoBanner_980px: "".concat(baseUrl, "illustrations/promo_banner_980px.svg"),
    promoBulkRooms_100px: "".concat(baseUrl, "illustrations/promo_bulk_rooms_100px.svg"),
    promoBulkRooms_320px: "".concat(baseUrl, "illustrations/promo_bulk_rooms_320px.svg"),
    promoBulkRooms_544px: "".concat(baseUrl, "illustrations/promo_bulk_rooms_544px.svg"),
    promoBulkSend_100px: "".concat(baseUrl, "illustrations/promo_bulk_send_100px.svg"),
    promoBulkSend_320px: "".concat(baseUrl, "illustrations/promo_bulk_send_320px.svg"),
    promoBulkSend_544px: "".concat(baseUrl, "illustrations/promo_bulk_send_544px.svg"),
    promoLivechat_100px: "".concat(baseUrl, "illustrations/promo_livechat_100px.svg"),
    promoLivechat_320px: "".concat(baseUrl, "illustrations/promo_livechat_320px.svg"),
    promoLivechat_544px: "".concat(baseUrl, "illustrations/promo_livechat_544px.svg"),
    promoManage_100px: "".concat(baseUrl, "illustrations/promo_manage_100px.svg"),
    promoManage_320px: "".concat(baseUrl, "illustrations/promo_manage_320px.svg"),
    promoManage_544px: "".concat(baseUrl, "illustrations/promo_manage_544px.svg"),
    promoPaidConversion_100px: "".concat(baseUrl, "illustrations/promo_paidConversion_100px.svg"),
    promoPaidConversion_320px: "".concat(baseUrl, "illustrations/promo_paidConversion_320px.svg"),
    promoPaidConversion_544px: "".concat(baseUrl, "illustrations/promo_paidConversion_544px.svg"),
    promoReferral_100px: "".concat(baseUrl, "illustrations/promo_referral_100px.svg"),
    promoReferral_320px: "".concat(baseUrl, "illustrations/promo_referral_320px.svg"),
    promoReferral_544px: "".concat(baseUrl, "illustrations/promo_referral_544px.svg"),
    promoSandbox_100px: "".concat(baseUrl, "illustrations/promo_sandbox_100px.png"),
    promoSandbox_320px: "".concat(baseUrl, "illustrations/promo_sandbox_320px.png"),
    promoSandbox_544px: "".concat(baseUrl, "illustrations/promo_sandbox_544px.png"),
    promoTemplate_100px: "".concat(baseUrl, "illustrations/promo_template_100px.svg"),
    promoTemplate_320px: "".concat(baseUrl, "illustrations/promo_template_320px.svg"),
    promoTemplate_544px: "".concat(baseUrl, "illustrations/promo_template_544px.svg"),
    promoUpgradeAlt_100px: "".concat(baseUrl, "illustrations/promo_upgrade-alt_100px.svg"),
    promoUpgradeAlt_320px: "".concat(baseUrl, "illustrations/promo_upgrade-alt_320px.svg"),
    promoUpgradeAlt_544px: "".concat(baseUrl, "illustrations/promo_upgrade-alt_544px.svg"),
    promoUpgrade_100px: "".concat(baseUrl, "illustrations/promo_upgrade_100px.svg"),
    promoUpgrade_320px: "".concat(baseUrl, "illustrations/promo_upgrade_320px.svg"),
    promoUpgrade_544px: "".concat(baseUrl, "illustrations/promo_upgrade_544px.svg"),
    promoZipform_100px: "".concat(baseUrl, "illustrations/promo_zipform_100px.svg"),
    promoZipform_320px: "".concat(baseUrl, "illustrations/promo_zipform_320px.svg"),
    promoZipform_544px: "".concat(baseUrl, "illustrations/promo_zipform_544px.svg"),
    reTrialChecklistForSale: "".concat(baseUrl, "illustrations/reTrialChecklistForSale.svg"),
    reTrialChecklistRealtorLogo: "".concat(baseUrl, "illustrations/reTrialChecklistRealtorLogo.svg"),
    reTrialModalFiles: "".concat(baseUrl, "illustrations/reTrialModalFiles.svg"),
    reTrialModalSigs: "".concat(baseUrl, "illustrations/reTrialModalSigs.svg"),
    reTrialModalStrikethrough: "".concat(baseUrl, "illustrations/reTrialModalStrikethrough.svg"),
    reTrialPostSendNarSig: "".concat(baseUrl, "illustrations/reTrialPostSendNARSig.svg"),
    reTrialPostSendTemplates: "".concat(baseUrl, "illustrations/reTrialPostSendTemplates.svg"),
    sampleDoc: "".concat(baseUrl, "illustrations/sample-doc.gif"),
    searchResultsSummary: "".concat(baseUrl, "illustrations/searchResultsSummary.svg"),
    searchWelcome: "".concat(baseUrl, "illustrations/searchWelcome.svg"),
    sendFirstDoc: "".concat(baseUrl, "illustrations/send_first_doc.svg"),
    switchToDesktop: "".concat(baseUrl, "illustrations/switchToDesktop.svg"),
    systemDownMaintenance: "".concat(baseUrl, "illustrations/system-down-maintenance.svg"),
    templateIcon: "".concat(baseUrl, "illustrations/template_icon.svg"),
    trackIcon: "".concat(baseUrl, "illustrations/track_icon.svg"),
    upgradeMonthlyAnnual: "".concat(baseUrl, "illustrations/upgrade-monthly-annual.svg"),
    upgradeTrialPaid: "".concat(baseUrl, "illustrations/upgrade-trial-paid.svg"),
    au: "".concat(baseUrl, "ink-country-flags/AU.svg"),
    bg: "".concat(baseUrl, "ink-country-flags/BG.svg"),
    br: "".concat(baseUrl, "ink-country-flags/BR.svg"),
    ca: "".concat(baseUrl, "ink-country-flags/CA.svg"),
    cz: "".concat(baseUrl, "ink-country-flags/CZ.svg"),
    de: "".concat(baseUrl, "ink-country-flags/DE.svg"),
    dk: "".concat(baseUrl, "ink-country-flags/DK.svg"),
    ee: "".concat(baseUrl, "ink-country-flags/EE.svg"),
    es: "".concat(baseUrl, "ink-country-flags/ES.svg"),
    fi: "".concat(baseUrl, "ink-country-flags/FI.svg"),
    fr: "".concat(baseUrl, "ink-country-flags/FR.svg"),
    gb: "".concat(baseUrl, "ink-country-flags/GB.svg"),
    ie: "".concat(baseUrl, "ink-country-flags/IE.svg"),
    jp: "".concat(baseUrl, "ink-country-flags/JP.svg"),
    nl: "".concat(baseUrl, "ink-country-flags/NL.svg"),
    no: "".concat(baseUrl, "ink-country-flags/NO.svg"),
    se: "".concat(baseUrl, "ink-country-flags/SE.svg"),
    us: "".concat(baseUrl, "ink-country-flags/US.svg"),
    fbwpChatBubbleSign: "".concat(baseUrl, "integrations/fbwpChatBubbleSign.png"),
    fbwpCommentReceived: "".concat(baseUrl, "integrations/fbwpCommentReceived.png"),
    fbwpCompleted: "".concat(baseUrl, "integrations/fbwpCompleted.png"),
    fbwpDeclined: "".concat(baseUrl, "integrations/fbwpDeclined.png"),
    fbwpNeedsToView: "".concat(baseUrl, "integrations/fbwpNeedsToView.png"),
    fbwpRecipientCompleted: "".concat(baseUrl, "integrations/fbwpRecipientCompleted.png"),
    fbwpReview: "".concat(baseUrl, "integrations/fbwpReview.png"),
    fbwpVoided: "".concat(baseUrl, "integrations/fbwpVoided.png"),
    ndiSignatureArea: "".concat(baseUrl, "integrations/ndiSignatureArea.png"),
    ndiSignatureArea_2x: "".concat(baseUrl, "integrations/ndiSignatureArea@2x.png"),
    ndiSingpassIcon: "".concat(baseUrl, "integrations/ndiSingpassIcon.png"),
    ndiSingpassIcon_2x: "".concat(baseUrl, "integrations/ndiSingpassIcon@2x.png"),
    ndiSingpassLogo: "".concat(baseUrl, "integrations/ndiSingpassLogo.png"),
    ndiSingpassLogo_2x: "".concat(baseUrl, "integrations/ndiSingpassLogo@2x.png"),
    ndiSingpassQrFrame: "".concat(baseUrl, "integrations/ndiSingpassQRFrame.png"),
    ndiSingpassQrFrame_2x: "".concat(baseUrl, "integrations/ndiSingpassQRFrame@2x.png"),
    ndiTranssped: "".concat(baseUrl, "integrations/ndiTranssped.png"),
    ndiTranssped_2x: "".concat(baseUrl, "integrations/ndiTranssped@2x.png"),
    ndiWatermark: "".concat(baseUrl, "integrations/ndiWatermark.png"),
    ndiWatermark_2x: "".concat(baseUrl, "integrations/ndiWatermark@2x.png"),
    tspLogoGeneric: "".concat(baseUrl, "integrations/tspLogoGeneric.svg"),
    tspLogoSingPass: "".concat(baseUrl, "integrations/tspLogoSingPass.svg"),
    tspLogoTransSped: "".concat(baseUrl, "integrations/tspLogoTransSped.png"),
    iamBanner: "".concat(baseUrl, "ipc/iamBanner.svg"),
    iamImage: "".concat(baseUrl, "ipc/iamImage.svg"),
    ipcIam: "".concat(baseUrl, "ipc/ipcIAM.png"),
    ipcOrgManagementSplashScreen: "".concat(baseUrl, "ipc/ipcOrgManagementSplashScreen.png"),
    ipcOrgManagementSplashScreenList: "".concat(baseUrl, "ipc/ipcOrgManagementSplashScreenList.png"),
    ipcOverageCampaign: "".concat(baseUrl, "ipc/ipcOverageCampaign.jpg"),
    ipcPostSendingBranding: "".concat(baseUrl, "ipc/ipcPostSendingBranding.png"),
    ipcPromoBlockG2AmericasLeader: "".concat(baseUrl, "ipc/ipcPromoBlockG2AmericasLeader.png"),
    ipcPromoBlockG2BestUsability: "".concat(baseUrl, "ipc/ipcPromoBlockG2BestUsability.png"),
    ipcPromoBlockG2EnterpriseLeader: "".concat(baseUrl, "ipc/ipcPromoBlockG2EnterpriseLeader.png"),
    ipcPromoBlockG2FallLeader: "".concat(baseUrl, "ipc/ipcPromoBlockG2FallLeader.png"),
    ipcPromoBlockG2MidMarketLeader: "".concat(baseUrl, "ipc/ipcPromoBlockG2MidMarketLeader.png"),
    ipcSidekickIaMv1: "".concat(baseUrl, "ipc/ipcSidekickIAMv1.jpg"),
    ipcSidekickIaMv2: "".concat(baseUrl, "ipc/ipcSidekickIAMv2.jpg"),
    ipcSplashScreenIaMv1: "".concat(baseUrl, "ipc/ipcSplashScreenIAMv1.jpg"),
    ipcSplashScreenIaMv2: "".concat(baseUrl, "ipc/ipcSplashScreenIAMv2.jpg"),
    ipcZoomLogoBlue: "".concat(baseUrl, "ipc/ipcZoomLogoBlue.jpg"),
    ipcZoomLogoWhite: "".concat(baseUrl, "ipc/ipcZoomLogoWhite.jpg"),
    postSendingMobileQr: "".concat(baseUrl, "ipc/postSendingMobileQR.svg"),
    freeTrialUnlock: "".concat(baseUrl, "ipg/freeTrialUnlock.svg"),
    postSendRedesignFirstEnvelope: "".concat(baseUrl, "ipg/postSendRedesignFirstEnvelope.svg"),
    questionnaireTaggerIllustration: "".concat(baseUrl, "ipg/questionnaireTaggerIllustration.svg"),
    sendVideoPreview: "".concat(baseUrl, "ipg/sendVideoPreview.svg"),
    sendVideoPreviewWithOverlay: "".concat(baseUrl, "ipg/sendVideoPreviewWithOverlay.svg"),
    accountDiscovery: "".concat(baseUrl, "ipg-virality-monetization/accountDiscovery.jpg"),
    error: "".concat(baseUrl, "login/error.svg"),
    info: "".concat(baseUrl, "login/info.svg"),
    passkeyDefault: "".concat(baseUrl, "login/passkey-default.svg"),
    passkeyError: "".concat(baseUrl, "login/passkey-error.svg"),
    passkeySuccess: "".concat(baseUrl, "login/passkey-success.svg"),
    selectTypeAuthenticatorAppActive: "".concat(baseUrl, "login/selectTypeAuthenticatorAppActive.svg"),
    selectTypeAuthenticatorAppDisabled: "".concat(baseUrl, "login/selectTypeAuthenticatorAppDisabled.svg"),
    selectTypeEmailActive: "".concat(baseUrl, "login/selectTypeEmailActive.svg"),
    selectTypeEmailDsiabled: "".concat(baseUrl, "login/selectTypeEmailDsiabled.svg"),
    selectTypePhoneNumberActive: "".concat(baseUrl, "login/selectTypePhoneNumberActive.svg"),
    selectTypePhoneNumberDisabled: "".concat(baseUrl, "login/selectTypePhoneNumberDisabled.svg"),
    selectTypeSecurityKeyActive: "".concat(baseUrl, "login/selectTypeSecurityKeyActive.svg"),
    selectTypeSecurityKeyDisabled: "".concat(baseUrl, "login/selectTypeSecurityKeyDisabled.svg"),
    twoStepVerificationAuthenticatorApp: "".concat(baseUrl, "login/twoStepVerificationAuthenticatorApp.svg"),
    twoStepVerificationEmail: "".concat(baseUrl, "login/twoStepVerificationEmail.svg"),
    twoStepVerificationPhoneNumberPhoneCall: "".concat(baseUrl, "login/twoStepVerificationPhoneNumberPhoneCall.svg"),
    twoStepVerificationPhoneNumberSms: "".concat(baseUrl, "login/twoStepVerificationPhoneNumberSMS.svg"),
    twoStepVerificationPhoneNumberSelectDeliveryMethod: "".concat(baseUrl, "login/twoStepVerificationPhoneNumberSelectDeliveryMethod.svg"),
    twoStepVerificationSecurityKey: "".concat(baseUrl, "login/twoStepVerificationSecurityKey.svg"),
    logoDocusignBlack: "".concat(baseUrl, "logo-docusign-black.png"),
    logoDocusignBlueBlack: "".concat(baseUrl, "logo-docusign-blue-black.png"),
    logoDocusignBlue: "".concat(baseUrl, "logo-docusign-blue.png"),
    logoDocusignGray: "".concat(baseUrl, "logo-docusign-gray.png"),
    logoDocusignSansBlack: "".concat(baseUrl, "logo-docusign-sans-black.png"),
    logoDocusignSansWhite: "".concat(baseUrl, "logo-docusign-sans-white.png"),
    logoDocusignSans: "".concat(baseUrl, "logo-docusign-sans.svg"),
    logoDocusignWhite: "".concat(baseUrl, "logo-docusign-white.png"),
    logoDocusign: "".concat(baseUrl, "logo-docusign.svg"),
    logoDsSansWhite: "".concat(baseUrl, "logo-ds-sans-white.svg"),
    boxDefault: "".concat(baseUrl, "logos/Box-default.png"),
    boxGray: "".concat(baseUrl, "logos/Box-gray.png"),
    boxWhite: "".concat(baseUrl, "logos/Box-white.png"),
    box: "".concat(baseUrl, "logos/Box.svg"),
    dropboxDefault: "".concat(baseUrl, "logos/Dropbox-default.png"),
    dropboxGray: "".concat(baseUrl, "logos/Dropbox-gray.png"),
    dropboxWhite: "".concat(baseUrl, "logos/Dropbox-white.png"),
    dropbox: "".concat(baseUrl, "logos/Dropbox.svg"),
    dtrDefault: "".concat(baseUrl, "logos/Dtr-default.png"),
    dtrGray: "".concat(baseUrl, "logos/Dtr-gray.png"),
    dtrWhite: "".concat(baseUrl, "logos/Dtr-white.png"),
    dtr: "".concat(baseUrl, "logos/Dtr.svg"),
    eoriginalDefault: "".concat(baseUrl, "logos/Eoriginal-default.png"),
    eoriginalGray: "".concat(baseUrl, "logos/Eoriginal-gray.png"),
    eoriginalWhite: "".concat(baseUrl, "logos/Eoriginal-white.png"),
    eoriginal: "".concat(baseUrl, "logos/Eoriginal.svg"),
    facebookDefault: "".concat(baseUrl, "logos/Facebook-default.png"),
    facebookGray: "".concat(baseUrl, "logos/Facebook-gray.png"),
    facebookWhite: "".concat(baseUrl, "logos/Facebook-white.png"),
    facebook: "".concat(baseUrl, "logos/Facebook.svg"),
    googleDriveDefault: "".concat(baseUrl, "logos/GoogleDrive-default.png"),
    googleDriveGray: "".concat(baseUrl, "logos/GoogleDrive-gray.png"),
    googleDriveWhite: "".concat(baseUrl, "logos/GoogleDrive-white.png"),
    googleDrive: "".concat(baseUrl, "logos/GoogleDrive.svg"),
    googlePlusDefault: "".concat(baseUrl, "logos/GooglePlus-default.png"),
    googlePlusGray: "".concat(baseUrl, "logos/GooglePlus-gray.png"),
    googlePlusWhite: "".concat(baseUrl, "logos/GooglePlus-white.png"),
    googlePlus: "".concat(baseUrl, "logos/GooglePlus.svg"),
    linkedInDefault: "".concat(baseUrl, "logos/LinkedIn-default.png"),
    linkedInGray: "".concat(baseUrl, "logos/LinkedIn-gray.png"),
    linkedInWhite: "".concat(baseUrl, "logos/LinkedIn-white.png"),
    linkedIn: "".concat(baseUrl, "logos/LinkedIn.svg"),
    microsoftDefault: "".concat(baseUrl, "logos/Microsoft-default.png"),
    microsoftGray: "".concat(baseUrl, "logos/Microsoft-gray.png"),
    microsoftWhite: "".concat(baseUrl, "logos/Microsoft-white.png"),
    microsoft: "".concat(baseUrl, "logos/Microsoft.svg"),
    office365Default: "".concat(baseUrl, "logos/Office365-default.png"),
    office365Gray: "".concat(baseUrl, "logos/Office365-gray.png"),
    office365White: "".concat(baseUrl, "logos/Office365-white.png"),
    office365: "".concat(baseUrl, "logos/Office365.svg"),
    oneDriveDefault: "".concat(baseUrl, "logos/OneDrive-default.png"),
    oneDriveGray: "".concat(baseUrl, "logos/OneDrive-gray.png"),
    oneDriveWhite: "".concat(baseUrl, "logos/OneDrive-white.png"),
    oneDrive: "".concat(baseUrl, "logos/OneDrive.svg"),
    roomsDefault: "".concat(baseUrl, "logos/Rooms-default.png"),
    roomsGray: "".concat(baseUrl, "logos/Rooms-gray.png"),
    roomsWhite: "".concat(baseUrl, "logos/Rooms-white.png"),
    rooms: "".concat(baseUrl, "ndse/rooms.svg"),
    salesforceDefault: "".concat(baseUrl, "logos/Salesforce-default.png"),
    salesforceGray: "".concat(baseUrl, "logos/Salesforce-gray.png"),
    salesforceWhite: "".concat(baseUrl, "logos/Salesforce-white.png"),
    salesforce: "".concat(baseUrl, "logos-products/salesforce.svg"),
    twitterDefault: "".concat(baseUrl, "logos/Twitter-default.png"),
    twitterGray: "".concat(baseUrl, "logos/Twitter-gray.png"),
    twitterWhite: "".concat(baseUrl, "logos/Twitter-white.png"),
    twitter: "".concat(baseUrl, "logos/Twitter.svg"),
    yahooDefault: "".concat(baseUrl, "logos/Yahoo-default.png"),
    yahooGray: "".concat(baseUrl, "logos/Yahoo-gray.png"),
    yahooWhite: "".concat(baseUrl, "logos/Yahoo-white.png"),
    yahoo: "".concat(baseUrl, "logos/Yahoo.svg"),
    appStoreBadge: "".concat(baseUrl, "logos-products/app-store-badge.svg"),
    docusignClmBlack: "".concat(baseUrl, "logos-products/docusignCLM-black.png"),
    docusignClmWhite: "".concat(baseUrl, "logos-products/docusignCLM-white.png"),
    docusignClMspringBlack: "".concat(baseUrl, "logos-products/docusignCLMspring-black.png"),
    docusignClMspringWhite: "".concat(baseUrl, "logos-products/docusignCLMspring-white.png"),
    googleChrome: "".concat(baseUrl, "logos-products/google-chrome.svg"),
    googleGmail: "".concat(baseUrl, "logos-products/google-gmail.svg"),
    googlePlayBadge: "".concat(baseUrl, "logos-products/google-play-badge.svg"),
    logoSpringcm: "".concat(baseUrl, "logos-products/logo-springcm.svg"),
    microsoftOutlook: "".concat(baseUrl, "logos-products/microsoft-outlook.svg"),
    mobileWeb: "".concat(baseUrl, "mobile-web/mobile-web.svg"),
    mwComments_24x24: "".concat(baseUrl, "mobile-web/mw-comments-24x24.svg"),
    mwPlus_24x24: "".concat(baseUrl, "mobile-web/mw-plus-24x24.svg"),
    addMarkup: "".concat(baseUrl, "ndse/add-markup.gif"),
    addUser: "".concat(baseUrl, "ndse/add-user.svg"),
    addingFields: "".concat(baseUrl, "ndse/adding-fields.gif"),
    apps: "".concat(baseUrl, "ndse/apps.svg"),
    autoTagging: "".concat(baseUrl, "ndse/auto-tagging.gif"),
    automation: "".concat(baseUrl, "ndse/automation.svg"),
    backgroundWelcome: "".concat(baseUrl, "ndse/background-welcome.svg"),
    brand: "".concat(baseUrl, "ndse/brand.svg"),
    bulkSend: "".concat(baseUrl, "ndse/bulk-send.svg"),
    collaboration: "".concat(baseUrl, "ndse/collaboration.svg"),
    deletePdfFormFields: "".concat(baseUrl, "ndse/delete-pdf-form-fields.svg"),
    diagramOutlines: "".concat(baseUrl, "ndse/diagram-outlines.svg"),
    documentGray: "".concat(baseUrl, "ndse/documentGray.svg"),
    documentGrayDarkSmall: "".concat(baseUrl, "ndse/documentGrayDarkSmall.svg"),
    documentGraySmall: "".concat(baseUrl, "ndse/documentGraySmall.svg"),
    downloadMobileApp: "".concat(baseUrl, "ndse/download-mobile-app.svg"),
    firstEnvelope: "".concat(baseUrl, "ndse/first_envelope.png"),
    flattenPdfFormFields: "".concat(baseUrl, "ndse/flatten-pdf-form-fields.svg"),
    generic: "".concat(baseUrl, "ndse/generic.svg"),
    ghostFieldMenu: "".concat(baseUrl, "ndse/ghostFieldMenu.svg"),
    homeBulkRooms: "".concat(baseUrl, "ndse/home-bulk-rooms.svg"),
    homeBulkSend: "".concat(baseUrl, "ndse/home-bulk-send.svg"),
    homeHeroBg_768px: "".concat(baseUrl, "ndse/home-hero-bg-768px.svg"),
    homeHeroBg: "".concat(baseUrl, "ndse/home-hero-bg.svg"),
    homeOptIn: "".concat(baseUrl, "ndse/home-optIn.svg"),
    iconBranding: "".concat(baseUrl, "ndse/icon-branding.svg"),
    iconHeadset: "".concat(baseUrl, "ndse/icon-headset.svg"),
    iconMobilephone: "".concat(baseUrl, "ndse/icon-mobilephone.svg"),
    iconOfficehours: "".concat(baseUrl, "ndse/icon-officehours.svg"),
    iconReferafriend: "".concat(baseUrl, "ndse/icon-referafriend.svg"),
    iconUploadprofilepic: "".concat(baseUrl, "ndse/icon-uploadprofilepic.svg"),
    identify: "".concat(baseUrl, "ndse/identify.svg"),
    inAppChatAgent: "".concat(baseUrl, "ndse/in-app-chat-agent.svg"),
    inAppChatBot: "".concat(baseUrl, "ndse/in-app-chat-bot.svg"),
    integration: "".concat(baseUrl, "ndse/integration.svg"),
    liveChat: "".concat(baseUrl, "ndse/live-chat.svg"),
    mergePdfFormFields: "".concat(baseUrl, "ndse/merge-pdf-form-fields.svg"),
    mobile: "".concat(baseUrl, "ndse/mobile.svg"),
    navigatorList: "".concat(baseUrl, "ndse/navigatorList.svg"),
    onboardingBrandYourAccount: "".concat(baseUrl, "ndse/onboarding-brand-your-account.svg"),
    onboardingCreateTemplate: "".concat(baseUrl, "ndse/onboarding-create-template.svg"),
    onboardingProfilePhoto: "".concat(baseUrl, "ndse/onboarding-profile-photo.svg"),
    onboardingSend: "".concat(baseUrl, "ndse/onboarding-send.svg"),
    onboardingSignDoc: "".concat(baseUrl, "ndse/onboarding-sign-doc.svg"),
    onboardingSignUp: "".concat(baseUrl, "ndse/onboarding-sign-up.svg"),
    onboardingSignYourDoc: "".concat(baseUrl, "ndse/onboarding-sign-your-doc.svg"),
    paymentDescriptionHint: "".concat(baseUrl, "ndse/payment-description-hint.svg"),
    personWithEnvelopeBox: "".concat(baseUrl, "ndse/person-with-envelope-box.png"),
    reLogoCar: "".concat(baseUrl, "ndse/reLogoCar.svg"),
    reLogoGar: "".concat(baseUrl, "ndse/reLogoGar.png"),
    reLogoNar: "".concat(baseUrl, "ndse/reLogoNAR.svg"),
    reLogoNwmls: "".concat(baseUrl, "ndse/reLogoNWMLS.png"),
    reLogoOref: "".concat(baseUrl, "ndse/reLogoOref.svg"),
    reLogoTar: "".concat(baseUrl, "ndse/reLogoTar.png"),
    recentActivityEmptyState: "".concat(baseUrl, "ndse/recent-activity-empty-state.svg"),
    referral: "".concat(baseUrl, "ndse/referral.svg"),
    responsiveSigning: "".concat(baseUrl, "ndse/responsive-signing.gif"),
    saveTime: "".concat(baseUrl, "ndse/save-time.svg"),
    sigPlaceholder: "".concat(baseUrl, "ndse/sig-placeholder.svg"),
    signing: "".concat(baseUrl, "ndse/signing.svg"),
    strikethrough: "".concat(baseUrl, "ndse/strikethrough.gif"),
    successBgShapes: "".concat(baseUrl, "ndse/success-bg-shapes.svg"),
    success: "".concat(baseUrl, "ndse/success.png"),
    template: "".concat(baseUrl, "ndse/template.svg"),
    upgrade: "".concat(baseUrl, "ndse/upgrade.svg"),
    upgradeAddUser: "".concat(baseUrl, "ndse/upgradeAddUser.png"),
    upgradeMomentum2022: "".concat(baseUrl, "ndse/upgradeMomentum2022.png"),
    upgradeOnTheGo: "".concat(baseUrl, "ndse/upgradeOnTheGo.png"),
    upgradeSandbox: "".concat(baseUrl, "ndse/upgradeSandbox.png"),
    upgradeTemplates: "".concat(baseUrl, "ndse/upgradeTemplates.png"),
    webforms: "".concat(baseUrl, "ndse/webforms.svg"),
    welcomeAddDocument: "".concat(baseUrl, "ndse/welcome_add_document.svg"),
    welcomeArrow: "".concat(baseUrl, "ndse/welcome_arrow.svg"),
    welcomeGetSignatures: "".concat(baseUrl, "ndse/welcome_get_signatures.svg"),
    welcomeShareAndManage: "".concat(baseUrl, "ndse/welcome_share_and_manage.svg"),
    newFavicon: "".concat(baseUrl, "new_favicon.png"),
    paymentAmex: "".concat(baseUrl, "payments/payment-amex.svg"),
    paymentAth: "".concat(baseUrl, "payments/payment-ath.svg"),
    paymentBccard: "".concat(baseUrl, "payments/payment-bccard.svg"),
    paymentCabal: "".concat(baseUrl, "payments/payment-cabal.svg"),
    paymentCartesBancaires: "".concat(baseUrl, "payments/payment-cartesBancaires.svg"),
    paymentChinaUnionPay: "".concat(baseUrl, "payments/payment-chinaUnionPay.svg"),
    paymentDinacard: "".concat(baseUrl, "payments/payment-dinacard.svg"),
    paymentDinersClub: "".concat(baseUrl, "payments/payment-dinersClub.svg"),
    paymentDirectDebit: "".concat(baseUrl, "payments/payment-directDebit.svg"),
    paymentDiscover: "".concat(baseUrl, "payments/payment-discover.svg"),
    paymentElo: "".concat(baseUrl, "payments/payment-elo.svg"),
    paymentInterac: "".concat(baseUrl, "payments/payment-interac.svg"),
    paymentJcb: "".concat(baseUrl, "payments/payment-jcb.svg"),
    paymentMaestro: "".concat(baseUrl, "payments/payment-maestro.svg"),
    paymentMastercard: "".concat(baseUrl, "payments/payment-mastercard.svg"),
    paymentNaranja: "".concat(baseUrl, "payments/payment-naranja.svg"),
    paymentPaypal: "".concat(baseUrl, "payments/payment-paypal.svg"),
    paymentVisa: "".concat(baseUrl, "payments/payment-visa.svg"),
    personaAmyTempleton: "".concat(baseUrl, "personas/persona-amy-templeton.png"),
    personaArnoldMasterson: "".concat(baseUrl, "personas/persona-arnold-masterson.png"),
    personaBarbaraAgassi: "".concat(baseUrl, "personas/persona-barbara-agassi.png"),
    personaBrianMashiyama: "".concat(baseUrl, "personas/persona-brian-mashiyama.png"),
    personaCarlosSalvadores: "".concat(baseUrl, "personas/persona-carlos-salvadores.png"),
    personaCodyDwight: "".concat(baseUrl, "personas/persona-cody-dwight.png"),
    personaEricAlpert: "".concat(baseUrl, "personas/persona-eric-alpert.png"),
    personaFranzDeutsch: "".concat(baseUrl, "personas/persona-franz-deutsch.png"),
    personaIanConner: "".concat(baseUrl, "personas/persona-ian-conner.png"),
    personaIshaanUmed: "".concat(baseUrl, "personas/persona-ishaan-umed.png"),
    personaJoeColeman: "".concat(baseUrl, "personas/persona-joe-coleman.png"),
    personaKarenVincent: "".concat(baseUrl, "personas/persona-karen-vincent.png"),
    personaLawrenceConway: "".concat(baseUrl, "personas/persona-lawrence-conway.png"),
    personaMartinYang: "".concat(baseUrl, "personas/persona-martin-yang.png"),
    personaPaulaAdams: "".concat(baseUrl, "personas/persona-paula-adams.png"),
    personaRachelSimbell: "".concat(baseUrl, "personas/persona-rachel-simbell.png"),
    personaRonAndreas: "".concat(baseUrl, "personas/persona-ron-andreas.png"),
    personaSanjayIyer: "".concat(baseUrl, "personas/persona-sanjay-iyer.png"),
    personaSherylCeilmann: "".concat(baseUrl, "personas/persona-sheryl-ceilmann.png"),
    personaSophiaVilla: "".concat(baseUrl, "personas/persona-sophia-villa.png"),
    personaTamaraMargen: "".concat(baseUrl, "personas/persona-tamara-margen.png"),
    personaUmarAzad: "".concat(baseUrl, "personas/persona-umar-azad.png"),
    stepCompleteBlack: "".concat(baseUrl, "progress-indicator/step-complete-black.png"),
    stepCompleteBluedis: "".concat(baseUrl, "progress-indicator/step-complete-bluedis.png"),
    stepCompleteBluefun: "".concat(baseUrl, "progress-indicator/step-complete-bluefun.png"),
    stepCompleteGray6: "".concat(baseUrl, "progress-indicator/step-complete-gray6.png"),
    stepCompleteTurquoise: "".concat(baseUrl, "progress-indicator/step-complete-turquoise.png"),
    stepCompleteWhite: "".concat(baseUrl, "progress-indicator/step-complete-white.png"),
    stepComplete: "".concat(baseUrl, "progress-indicator/step-complete.svg"),
    stepIncompleteBlack: "".concat(baseUrl, "progress-indicator/step-incomplete-black.png"),
    stepIncompleteBluedis: "".concat(baseUrl, "progress-indicator/step-incomplete-bluedis.png"),
    stepIncompleteBluefun: "".concat(baseUrl, "progress-indicator/step-incomplete-bluefun.png"),
    stepIncompleteGray6: "".concat(baseUrl, "progress-indicator/step-incomplete-gray6.png"),
    stepIncompleteTurquoise: "".concat(baseUrl, "progress-indicator/step-incomplete-turquoise.png"),
    stepIncompleteWhite: "".concat(baseUrl, "progress-indicator/step-incomplete-white.png"),
    stepIncomplete: "".concat(baseUrl, "progress-indicator/step-incomplete.svg"),
    previewAllExpandedSection: "".concat(baseUrl, "send-flow/previewAllExpandedSection.svg"),
    previewOneExpandedSection: "".concat(baseUrl, "send-flow/previewOneExpandedSection.svg"),
    sigName: "".concat(baseUrl, "sig-name.gif"),
    tagApplied: "".concat(baseUrl, "signing-tags/tag-applied.svg"),
    tagAttachment: "".concat(baseUrl, "tags/tag-attachment.svg"),
    tagInitials: "".concat(baseUrl, "signing-tags/tag-initials.svg"),
    tagSignature: "".concat(baseUrl, "signing-tags/tag-signature.svg"),
    tagStampJp: "".concat(baseUrl, "signing-tags/tag-stamp-jp.svg"),
    tagStamp: "".concat(baseUrl, "tags/tag-stamp.svg"),
    taggerIcons: "".concat(baseUrl, "tagger-icons.svg"),
    deTagInitialsNew: "".concat(baseUrl, "tags/de/de-tag-initials-new.svg"),
    deTagInitials: "".concat(baseUrl, "tags/de/de-tag-initials.svg"),
    deTagSignatureNew: "".concat(baseUrl, "tags/de/de-tag-signature-new.svg"),
    deTagSignature: "".concat(baseUrl, "tags/de/de-tag-signature.svg"),
    enTagInitialsNew: "".concat(baseUrl, "tags/en/en-tag-initials-new.svg"),
    enTagInitials: "".concat(baseUrl, "tags/en/en-tag-initials.svg"),
    enTagSignatureNew: "".concat(baseUrl, "tags/en/en-tag-signature-new.svg"),
    enTagSignature: "".concat(baseUrl, "tags/en/en-tag-signature.svg"),
    esTagInitialsNew: "".concat(baseUrl, "tags/es/es-tag-initials-new.svg"),
    esTagInitials: "".concat(baseUrl, "tags/es/es-tag-initials.svg"),
    esTagSignatureNew: "".concat(baseUrl, "tags/es/es-tag-signature-new.svg"),
    esTagSignature: "".concat(baseUrl, "tags/es/es-tag-signature.svg"),
    frTagInitialsNew: "".concat(baseUrl, "tags/fr/fr-tag-initials-new.svg"),
    frTagInitials: "".concat(baseUrl, "tags/fr/fr-tag-initials.svg"),
    frTagSignatureNew: "".concat(baseUrl, "tags/fr/fr-tag-signature-new.svg"),
    frTagSignature: "".concat(baseUrl, "tags/fr/fr-tag-signature.svg"),
    itTagInitialsNew: "".concat(baseUrl, "tags/it/it-tag-initials-new.svg"),
    itTagInitials: "".concat(baseUrl, "tags/it/it-tag-initials.svg"),
    itTagSignatureNew: "".concat(baseUrl, "tags/it/it-tag-signature-new.svg"),
    itTagSignature: "".concat(baseUrl, "tags/it/it-tag-signature.svg"),
    jaTagInitialsNew: "".concat(baseUrl, "tags/ja/ja-tag-initials-new.svg"),
    jaTagInitials: "".concat(baseUrl, "tags/ja/ja-tag-initials.svg"),
    jaTagSignatureNew: "".concat(baseUrl, "tags/ja/ja-tag-signature-new.svg"),
    jaTagSignature: "".concat(baseUrl, "tags/ja/ja-tag-signature.svg"),
    koTagInitialsNew: "".concat(baseUrl, "tags/ko/ko-tag-initials-new.svg"),
    koTagInitials: "".concat(baseUrl, "tags/ko/ko-tag-initials.svg"),
    koTagSignatureNew: "".concat(baseUrl, "tags/ko/ko-tag-signature-new.svg"),
    koTagSignature: "".concat(baseUrl, "tags/ko/ko-tag-signature.svg"),
    nlTagInitialsNew: "".concat(baseUrl, "tags/nl/nl-tag-initials-new.svg"),
    nlTagInitials: "".concat(baseUrl, "tags/nl/nl-tag-initials.svg"),
    nlTagSignatureNew: "".concat(baseUrl, "tags/nl/nl-tag-signature-new.svg"),
    nlTagSignature: "".concat(baseUrl, "tags/nl/nl-tag-signature.svg"),
    plTagInitialsNew: "".concat(baseUrl, "tags/pl/pl-tag-initials-new.svg"),
    plTagInitials: "".concat(baseUrl, "tags/pl/pl-tag-initials.svg"),
    plTagSignatureNew: "".concat(baseUrl, "tags/pl/pl-tag-signature-new.svg"),
    plTagSignature: "".concat(baseUrl, "tags/pl/pl-tag-signature.svg"),
    ptTagInitialsNew: "".concat(baseUrl, "tags/pt/pt-tag-initials-new.svg"),
    ptTagInitials: "".concat(baseUrl, "tags/pt/pt-tag-initials.svg"),
    ptTagSignatureNew: "".concat(baseUrl, "tags/pt/pt-tag-signature-new.svg"),
    ptTagSignature: "".concat(baseUrl, "tags/pt/pt-tag-signature.svg"),
    ptBrTagInitialsNew: "".concat(baseUrl, "tags/pt_BR/pt_BR-tag-initials-new.svg"),
    ptBrTagInitials: "".concat(baseUrl, "tags/pt_BR/pt_BR-tag-initials.svg"),
    ptBrTagSignatureNew: "".concat(baseUrl, "tags/pt_BR/pt_BR-tag-signature-new.svg"),
    ptBrTagSignature: "".concat(baseUrl, "tags/pt_BR/pt_BR-tag-signature.svg"),
    ruTagInitialsNew: "".concat(baseUrl, "tags/ru/ru-tag-initials-new.svg"),
    ruTagInitials: "".concat(baseUrl, "tags/ru/ru-tag-initials.svg"),
    ruTagSignatureNew: "".concat(baseUrl, "tags/ru/ru-tag-signature-new.svg"),
    ruTagSignature: "".concat(baseUrl, "tags/ru/ru-tag-signature.svg"),
    tagHanko: "".concat(baseUrl, "tags/tag-hanko.svg"),
    zhCnTagInitialsNew: "".concat(baseUrl, "tags/zh_CN/zh_CN-tag-initials-new.svg"),
    zhCnTagInitials: "".concat(baseUrl, "tags/zh_CN/zh_CN-tag-initials.svg"),
    zhCnTagSignatureNew: "".concat(baseUrl, "tags/zh_CN/zh_CN-tag-signature-new.svg"),
    zhCnTagSignature: "".concat(baseUrl, "tags/zh_CN/zh_CN-tag-signature.svg"),
    zhTwTagInitialsNew: "".concat(baseUrl, "tags/zh_TW/zh_TW-tag-initials-new.svg"),
    zhTwTagInitials: "".concat(baseUrl, "tags/zh_TW/zh_TW-tag-initials.svg"),
    zhTwTagSignatureNew: "".concat(baseUrl, "tags/zh_TW/zh_TW-tag-signature-new.svg"),
    zhTwTagSignature: "".concat(baseUrl, "tags/zh_TW/zh_TW-tag-signature.svg"),
    tags: "".concat(baseUrl, "tags.svg"),
    applePay: "".concat(baseUrl, "vendor/apple-pay.svg"),
    paypal: "".concat(baseUrl, "vendor/paypal.svg"),
    stripe: "".concat(baseUrl, "vendor/stripe.png"),
    brandingFwGrey: "".concat(baseUrl, "video-thumbnails/branding_fw_grey.png"),
    brandingFwHover: "".concat(baseUrl, "video-thumbnails/branding_fw_hover.png"),
    bulksendFwGrey: "".concat(baseUrl, "video-thumbnails/bulksend_fw_grey.png"),
    bulksendFwHover: "".concat(baseUrl, "video-thumbnails/bulksend_fw_hover.png"),
    powerformFwGrey: "".concat(baseUrl, "video-thumbnails/powerform_fw_grey.png"),
    powerformFwHover: "".concat(baseUrl, "video-thumbnails/powerform_fw_hover.png"),
    sendHowToBulksend: "".concat(baseUrl, "video-thumbnails/send_how_to_bulksend.png"),
    templateFwGrey: "".concat(baseUrl, "video-thumbnails/template_fw_grey.png"),
    templateFwHover: "".concat(baseUrl, "video-thumbnails/template_fw_hover.png"),
    webFormsSelectStandaloneForm: "".concat(baseUrl, "webforms/webFormsSelectStandaloneForm.png"),
    webFormsSelectTemplateForm: "".concat(baseUrl, "webforms/webFormsSelectTemplateForm.png")
  };
});